import React, { useContext, useEffect, useRef, useState } from "react";
import ShadowLayer from "../../assets/bgScreenbg.webp";
import CustomButton from "./HomeCustomButton";
import MarkupGrid from "./HomeMarkupGrid";
import RowList from "../../components/RowList";
import ThumbnailnoImage from "../../assets/thumbnailNoImage.png";
import solidbackgroundimg from "../../assets/solidbackgroundimg.png";
import favouriteIcon from "../../assets/Added.png";
import addtofavouriteIcon from "../../assets/addtofavorite.png";
import selectedlikeIcon from "../../assets/selectedLike.png";
import selectedDislikeIcon from "../../assets/selectedDislike.png";
import likeIcon from "../../assets/like.png";
import dislikeIcon from "../../assets/dislike.png";
import start_over from "../../assets/start_over.png";
import idmdimg from "../../assets/idmdimg.png";
import { Translate } from "../../components/LanguageChanger";

import { toSentenceCase } from "../../utils/utils";
import Wrapper from "../../components/shared/Wrapper";
import backIcon from "../../assets/back-button.png";
import logoutIcon from "../../assets/Logout-Icon.png";
import dotIcon from "../../assets/dotIcon.png";

import {
  addLikeDisLike,
  addRemoveFavorite,
  addRemoveWatchlist,
  getRatings,
  getWatchList,
  setEventReminder,
  getComingSoon,
} from "../../services/services";
import { AppContext } from "../../AppContext";
import eyeIcon from "../../assets/mdi_eye.png";
import playIcon from "../../assets/playbuttonicon.png";
import bell_icon_selected from "../../assets/bell_icon_selected.png";
import bell_icon_unselected from "../../assets/bell_icon_unselected.png";
import HomeBGVideoPlayer from "../../components/HomeBGVideoPlayer";
import { sendEvent, sendEventAction, sendSimilarThisEvent } from "../../Analytics/MatomoManager/detailMatomoMedia";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";

let subscriptionCheck = false;
let addKeyListener;
let focusedIndex = 1;
let resolution = window.RESOLUTION;
let ReseTfocus1;
let isKeyListenerAdded = false; // Flag to track if the event listener is added
var currentScreen;
let SetFocusTodefault;
var seasonTab = [];
var artist = [];
var similar = [];
var Episodes = [];
let flg = false;
let isDeleted;
let Dislike;
let like;
let bottomShelfTabTitle = [];
let isStartOverSelectedButton = false;

let watchlistItems_local = [];

let API_IN_PROGRESS = false;
let WATCHLIST_LOCKED = false;

const HomeScreenBGItemScreen = ({
  dataItem,
  shouldRental,
  isError,
  banneritems,
  callBack,
  animation,
  navigate,
  isDetails,
  FocusHandler,
  shouldFocusToScreenBG,
  isLogedIn,
  itemDetails,
  isSeriess = false,
  handleErr,
  onSelect,
  isLiveEvent,
  getItemDetails,
  isLiveScreen,
  screenName,
  shouldRemindPopup,
  shouldAuthError,
  shouldShowAuthModal,
  VideoDataDrm,
}) => {

  const [rerender, setrerenderState] = useState({ rerender: false });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [imgSrc, setImgSrc] = useState(addtofavouriteIcon);
  const [isNavigating, setIsNavigating] = useState(false);
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const eventFiredRef = useRef(false);
  const [readMore, setReadMore] = useState(false);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [videoURL, setVideoURL] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  console.log(VideoDataDrm, "videoDataDrm");

  const [state, setState] = useState({
    isWatchNowSelected: shouldFocusToScreenBG ? true : false,
    isMoreInfoSelected: false,
    isAddFavoriteSelected: false,
    isBelliconSelected: false,
    isStartOverSelected: false,
    isLikeSelected: false,
    isReadMoreSelected: false,
    isDislikeSelected: false,
    isSeries: isSeriess,
    isBackButtonSelected: false,
    isEpisodeSelected: false,
    isCastCreSelected: false,
    isSimilarSelected: false,
    loading: true,
    TabContent: [],
    watchlistItems: [],
    likeDislikeItems: [],
    shouldFocusGrid: false,
    shouldFocusToRowList: true,
    isAddFavoriteSelectedHeart: false,
    shouldFocusToSeasonRowList: false,
    shouldFocusToEpisodeGrid: false,
    shoulddetailsOpen: flg,
    shouldshowSeasonRowlist: false,
    itemComponentName: "EpisodesWidget",
    episodeMarginTop: "265px",
    selectedItemId: "",
  });
  const {
    isWatchNowSelected,
    isMoreInfoSelected,
    isAddFavoriteSelected,
    isStartOverSelected,
    isLikeSelected,
    isBelliconSelected,
    isDislikeSelected,
    isSeries,
    loading,
    isEpisodeSelected,
    isCastCreSelected,
    isSimilarSelected,
    isBackButtonSelected,
    TabContent,
    shouldFocusGrid,
    shouldFocusToRowList,
    shouldFocusToSeasonRowList,
    shouldFocusToEpisodeGrid,
    shoulddetailsOpen,
    shouldshowSeasonRowlist,
    itemComponentName,
    episodeMarginTop,
    watchlistItems,
    likeDislikeItems,
    isAddFavoriteSelectedHeart,
    selectedItemId,
    isReadMoreSelected,
  } = state;

  let headers = {};

  window.IS_PAID = itemDetails[0]?.is_paid;

  const watchlistDataCheck = async () => {
    //return if this Function was just called within few seconds
    if (WATCHLIST_LOCKED) {
      return;
    }
    setTimeout(() => {
      WATCHLIST_LOCKED = false;
    }, 2000);
    WATCHLIST_LOCKED = true;

    const userId = localStorage.getItem("profileId");
    if (
      localStorage.getItem("user_details") !== undefined &&
      localStorage.getItem("user_details") !== null
    ) {
    }
    if (isLogedIn) {
      try {
            const [
              response1,
              response2,
              response3,
              response4,
              response5
            ] = await Promise.all([
              getWatchList(userId, 1),
              getWatchList(userId, 2),
              getWatchList(userId, 3),
              getWatchList(userId, 4),
              getWatchList(userId, 5),
            ]);
        if (
          response1.data ||
          response2.data ||
          response3.data ||
          response4.data ||
          response5.data
        ) {
          const fetchedWatchedList = {
            response1,
            response2,
            response3,
            response4,
            response5,
          };
          const allWatchedListData = [
            ...fetchedWatchedList.response1.data,
            ...fetchedWatchedList.response2.data,
            ...fetchedWatchedList.response3.data,
            ...fetchedWatchedList.response4.data,
            ...fetchedWatchedList.response5.data,
          ];

          if (
            response1.data &&
            response2.data &&
            response3.data &&
            response4.data &&
            response5.data
          ) {
            watchlistItems_local = allWatchedListData;

          setState((prevState) => ({
            ...prevState,
            watchlistItems: allWatchedListData,
          }));
            API_IN_PROGRESS = false;
          }
        } else if (isLogedIn) {
          const userDetails = JSON.parse(
            localStorage.getItem("userID") || "{}"
          );
          if (
            !response1.success ||
            !response2.success ||
            !response3.success ||
            !response4.success ||
            !response5.success
          ) {
            setState((prevState) => ({
              ...prevState,
              loading: false,
              shouldFocusToGrid: false,
              shouldShowError: true,
              shouldCloseMenu: false,
            }));
            handleErr("AUTH-ERROR");

            return;
          }
        }
      } catch (error) {
        //console.error("Error fetching data:", error);
        setState((prevState) => ({
        ...prevState,
          loading: false,
          shouldFocusToGrid: false,
          shouldShowError: true,
          shouldCloseMenu: false,
      }));
    }
    }
  };
 
  const likeDislike = async () => {
    const userId = localStorage.getItem("profileId");
    if (
      localStorage.getItem("user_details") !== undefined &&
      localStorage.getItem("user_details") !== null
    ) {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
    }
    if (isLogedIn) {
      try {
        const [
              response1,
              response2,
              response3,
              response4,
              response5
            ] = await Promise.all([
              getRatings(userId, 1),
              getRatings(userId, 2),
              getRatings(userId, 3),
              getRatings(userId, 4),
              getRatings(userId, 5),
            ]);
        if (
          response1.data ||
          response2.data ||
          response3.data ||
          response4.data ||
          response5.data
        ) {
          const fetchedlikedList = {
            response1,
            response2,
            response3,
            response4,
            response5,
          };
      
          const likeDislikeData = [
            ...fetchedlikedList.response1.data,
            ...fetchedlikedList.response2.data,
            ...fetchedlikedList.response3.data,
            ...fetchedlikedList.response4.data,
            ...fetchedlikedList.response5.data,
          ];
  
          setState((prevState) => ({
            ...prevState,
            loading: false,
            bgColor: "#000000",
            shouldFocusToGrid: true,
            likeDislikeItems: likeDislikeData,
          }));
        } else if (isLogedIn) {
          if (
            !response1.success ||
            !response2.success ||
            !response3.success ||
            !response4.success ||
            !response5.success
          ) {
            const userDetails = JSON.parse(
              localStorage.getItem("userID") || "{}"
            );
            setState((prevState) => ({
              ...prevState,
              loading: false,
              shouldFocusToGrid: false,
              shouldShowError: true,
              shouldCloseMenu: false,
            }));
            handleErr("AUTH-ERROR");
            return;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        window.removeEventListener("keydown", BGScreenKeyHandler);
        setState((prevState) => ({
          ...prevState,
          loading: false,
          isWatchNowSelected: false,
          isMoreInfoSelected: false,
          isAddFavoriteSelected: false,
          isLikeSelected: false,
          isDislikeSelected: false,
          isBackButtonSelected: false,
          isBelliconSelected: false,
          shouldFocusToScreenBG: false,
          shouldFocusToGrid: false,
          shouldAuthError: true,
          shouldShowError: true,
          shouldCloseMenu: false,
        }));
        handleErr("AUTH-ERROR");
      }
    }
  };

  addKeyListener = () => {
    if (!isKeyListenerAdded) {
      let tmr = setTimeout(function () {
        clearTimeout(tmr);
        window.removeEventListener("keydown", BGScreenKeyHandler);
        window.addEventListener("keydown", BGScreenKeyHandler);
      }, 500);
      isKeyListenerAdded = true; // Set the flag to true
      setState((prevState) => ({
        ...prevState,
        isWatchNowSelected: true,
        isMoreInfoSelected: false,
      }));
      focusedIndex = 1;
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    let formattedTime = "";

    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }

    return formattedTime.trim(); // To ensure no extra spaces.
  };

  ReseTfocus1 = () => {
    focusedIndex = 1;
  };

  SetFocusTodefault = (focusedIndex) => {
    if (focusedIndex >= 0) {
      currentScreen = "DetailScreen";
      prevIndex = focusedIndex;
      setCurrentIndex = focusedIndex;
      setrerenderState({ rerender: !rerender });
    } else {
      currentIndex = prevIndex;
      setrerenderState({ rerender: !rerender });
    }
  };

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };

  console.log(data, "alert1");

  useEffect(() => {
      if(isError){
      setState((prevState) => ({
                ...prevState,
                isReadMoreSelected: false,
                isBackButtonSelected: true,
                isWatchNowSelected: false,
                isAddFavoriteSelected: false,
                isLikeSelected: false,
                isDislikeSelected: false,
                isCastCreSelected: false,
                isSimilarSelected: false,
                isEpisodeSelected: false,
              }));
      focusedIndex = 11;
    }
    checkAddedComing(itemDetails);
    if (shouldRemindPopup) {
      setState((prevState) => ({
        ...prevState,
        isBelliconSelected: true,
      }));
    }

    if (itemDetails[0]?.isTeaser === 1) {
      const videoObj = itemDetails[0]?.season?.[0]?.videos?.find(
        (vid) => vid.is_trailer === 0
      );

      if (videoObj?.file_url) {
        setVideoURL(videoObj.file_url);
      }
    }
    if (shouldFocusToScreenBG) {
      setTimeout(function () {
        addKeyListener();
        if (!isNavigating) {
        // nothing
        }
      }, 300);
    } else {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false; // Reset the flag
    }
  }, [itemDetails,isError]);

  useEffect(() => {
    artist = [];
    similar = [];
    Episodes = [];
    seasonTab = [];
    bottomShelfTabTitle = [];
    watchlistDataCheck();
    likeDislike();

    if (!itemDetails || itemDetails.length === 0) {
      return;
    }

    // For live screens, we do not need to process episodes, tracks, or cast.
    // We only care about similar channels.
    if (isLiveScreen || isLiveEvent || itemDetails[0]?.still_live === 1) {
      similar =
        itemDetails[0]?.related?.filter((item) => item?.still_live === 1) ||
        itemDetails[0]?.similar?.filter((item) => item.still_live === 1) ||
        [];

      if (similar.length > 0) {
        bottomShelfTabTitle.push({
          id: "similaritems",
          title: <Translate langKey={"similar_channels"} />,
        });
        setState((prevState) => ({
          ...prevState,
          TabContent: similar,
          isSimilarSelected: true,
          selectedItemId: "similaritems",
          isEpisodeSelected: false,
          isCastCreSelected: false,
          shouldshowSeasonRowlist: false,
          // shoulddetailsOpen:false,
        }));
      } else {
        // If there's nothing to show, clear the state.
        setState((prevState) => ({
          ...prevState,
          TabContent: [],
          isEpisodeSelected: false,
          isCastCreSelected: false,
          isSimilarSelected: false,
        }));
      }
      return; // IMPORTANT: Exit here for live screens
    }

    // The rest of this logic is for ON-DEMAND content (not live)
    // Process Video on Demand (VOD)
    if (itemDetails[0]?.type === 0 || itemDetails[0]?.media_type === 0) {
      const seriesInfo = itemDetails[0].season;
      if (
        seriesInfo &&
        seriesInfo.length > 0 &&
        itemDetails[0].skip_season === 0
      ) {
        // Logic to process seasons and episodes for VOD
        for (let i = 0; i < itemDetails[0].season.length; i++) {
          let season = itemDetails[0].season[i];
          seasonTab.push({ id: season.id, title: `Season ${season.number}` });
          if (season.artist && season.artist.length > 0) {
            artist.push(...season.artist.map(a => ({
              title: a.artists_name,
              thumbnail: a.profile_image,
              artist_type_name: a.artists_type_name
            })));
          }
          if (season.videos && season.videos.length > 0) {
            Episodes.push({
              seasonTitle: `Season ${season.number}`,
              seasonID: season.id,
              episodes: season.videos
            });
          }
        }
      } else {
        // Logic to process artists for single movies/videos
        if(itemDetails[0].season) {
            for (let i = 0; i < itemDetails[0].season.length; i++) {
                let season = itemDetails[0].season[i];
                 if (season.artist && season.artist.length > 0) {
                    artist.push(...season.artist.map(a => ({
                        title: a.artists_name,
                        thumbnail: a.profile_image,
                        artist_type_name: a.artists_type_name
                    })));
                }
            }
        }
      }
    }
    // Process Audio on Demand (AOD)
    else if (itemDetails[0]?.type === 1 || itemDetails[0]?.media_type === 1) {
      const seriesInfo = itemDetails[0].season;
      if (seriesInfo && seriesInfo.length > 0) {
        for (let i = 0; i < itemDetails[0].season.length; i++) {
            let season = itemDetails[0].season[i];
            seasonTab.push({ id: season.id, title:    <Translate langKey={ "Tracks"} />});
             if (season.artist && season.artist.length > 0) {
                artist.push(...season.artist.map(a => ({
                    title: a.artists_name,
                    thumbnail: a.profile_image,
                    artist_type_name: a.artists_type_name
                })));
            }
             if (season.videos && season.videos.length > 0) {
                Episodes.push({
                    seasonTitle:<Translate langKey={ "Tracks"} />,
                    seasonID: season.id,
                    episodes: season.videos
                });
            }
        }
      }
    }

    // Get similar content for on-demand items
    similar = itemDetails[0]?.related?.filter(item => item.still_live === 0) || [];

    // Build the bottom shelf tabs for on-demand content
    if (Episodes.length > 0) {
        bottomShelfTabTitle.push({
            id: "episodes",
            title: itemDetails[0]?.type === 1 ?    <Translate langKey={ "Tracks"} /> : <Translate langKey={"episodes"} />,
        });
    }
    if (artist.length > 0) {
        bottomShelfTabTitle.push({
            id: "castcrew",
            title: <Translate langKey={"cast_crew"} />,
        });
    }
    if (similar.length > 0) {
        bottomShelfTabTitle.push({
            id: "similaritems",
            title: <Translate langKey={"similar_to_this"} />,
        });
    }

    // Set the default view for on-demand content
    if (Episodes.length > 0) {
        setState((prevState) => ({
            ...prevState,
            isSeries: true,
            isEpisodeSelected: true,
            selectedItemId: "episodes",
            isCastCreSelected: false,
            isSimilarSelected: false,
            TabContent: Episodes[0].episodes,
            shouldshowSeasonRowlist: true,
            // shoulddetailsOpen: false,
        }));
    } else if (artist.length > 0) {
        setState((prevState) => ({
            ...prevState,
            isSeries: false,
            TabContent: artist,
            isEpisodeSelected: false,
            isCastCreSelected: true,
            selectedItemId: "castcrew",
            isSimilarSelected: false,
            // shoulddetailsOpen: false,
        }));
    } else if (similar.length > 0) {
        setState((prevState) => ({
            ...prevState,
            TabContent: similar,
            isSimilarSelected: true,
            selectedItemId: "similaritems",
            isEpisodeSelected: false,
            isCastCreSelected: false,
            // shoulddetailsOpen: false,
        }));
    }
    seasonTab = seasonTab.sort((a, b) => {
            const numA = parseInt(a.title.replace(/\D/g, ""), 10); // only digits
            const numB = parseInt(b.title.replace(/\D/g, ""), 10);
            return numA - numB; // ascending
          });

  }, [itemDetails, isLiveScreen, isLiveEvent]);

  const AddDelWatchList = async (item) => {
    if (API_IN_PROGRESS) {
      //open to Log
      API_IN_PROGRESS = false;
      return;
    }
    const userId = localStorage.getItem("profileId");
    try {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      let headers = {
        Langid: "1",
        profileid: userId,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };
      let isFound1 = watchlistItems_local.find(
        (data) => data.show_id === item.id && data.is_deleted === 0
      )
        ? 1
        : 0;
      let isFound2 = watchlistItems_local.find(
        (data) => data.show_id === item.show_id && data.is_deleted === 0
      )
        ? 1
        : 0;
      let isFound3 = watchlistItems_local.find(
        (data) => data.id === item.id && data.is_deleted === 0
      )
        ? 1
        : 0;

      if (isFound1 || isFound2 || isFound3) {
        isDeleted = 1;
      } else {
        isDeleted = 0;
      }
      API_IN_PROGRESS = true;
      if (item.id) {
        let postParam = [{ show_id: item.id, is_deleted: isDeleted }];
        const watchlistAddDelResponse1 = await addRemoveWatchlist(
          postParam,
          headers
        );
      }

      if (item.show_id) {
        let postParam = [{ show_id: item.show_id, is_deleted: isDeleted }];
        const watchlistAddDelResponse2 = await addRemoveWatchlist(
          postParam,
          headers
        );
      }

      setTimeout(() => {
        watchlistDataCheck();
      }, 100);

      focusedIndex = 2;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelected: true,
        isWatchNowSelected: false,
      }));


      const eventAction = isDeleted === 1 ? "Delete" : "Add";

      // Matomo Event for  watchlist
      sendEventAction({action:eventAction, type:"watchlist",item:item,sourceContext:sourceContext});


    } catch (error) {
      console.error("Error fetching data:", error);
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      handleErr("WATCHLISTADD-ERROR");
      focusedIndex = 1;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelected: false,
      }));
    }
  };

  const AddToFavourite = async (item) => {
    console.log("AddToFavourite....", item);
    const userId = localStorage.getItem("profileId");
    try {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      let headers = {
        Langid: "1",
        profileid: userId,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };
      let postParam = [{ show_id: item.id, is_deleted: "0", channel_id: "0" }];
      const watchlistAddDelResponse = await addRemoveFavorite(
        JSON.stringify(postParam)
      );
      focusedIndex = 2;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelectedHeart: true,
      }));
      console.log("isAddFavoriteSelectedHeart", watchlistAddDelResponse);
    } catch (error) {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      handleErr("WATCHLISTADD-ERROR");
      focusedIndex = 1;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelectedHeart: false,
      }));
    }
  };

  const RemoveToFavourite = async (item) => {
    const userId = localStorage.getItem("profileId");
    try {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      let headers = {
        Langid: "1",
        profileid: userId,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };
      let postParam = [
        { show_id: item.id, is_deleted: isDeleted, channel_id: "" },
      ];

      const watchlistAddDelResponse = await addRemoveFavorite(
        JSON.stringify(postParam)
      );

      focusedIndex = 2;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelected: true,
      }));
    } catch (error) {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      handleErr("WATCHLISTADD-ERROR");
      focusedIndex = 1;
      setState((prevState) => ({
        ...prevState,
        isAddFavoriteSelected: false,
      }));
    }
  };

  const truncateText = (text) => {
    if (text?.length > 200) {
      if (
        !readMore &&
        banneritems[currentIndex]?.playlist_type === "upcoming"
      ) {
        return `${text?.slice(0, 200)}`;
      }
      if (readMore) {
        return text?.slice(0, 250);
      } else {
        const words = text?.split(" ");
        if (words?.length > 15) {
          return words?.slice(0, 15)?.join(" ") + "... ";
        }
        return text;
      }
    } else {
      return text;
    }
  };

  const AddlikeList = async (item) => {
    const userId = localStorage.getItem("profileId");
    try {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      let headers = {
        Langid: "1",
        profileid: userId,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };
      let ShowId = item?.id === undefined ? item.show_id : item.id;
      let postParam = [{ show_id: ShowId, rating: "like", is_deleted: 1 }];
      const addlikeDislikeResponse = await addLikeDisLike(postParam, headers);
      likeDislike();
    setState((prevState) => ({
      ...prevState,
      isLikeSelected: true,
        isWatchNowSelected: false,
        isAddFavoriteSelected: false,
      isDislikeSelected: false,
    }));
    focusedIndex = 3;
      

      // Send Matomo event for Like
      sendEventAction({action:"like", type:"likeDislike",item:item,sourceContext:sourceContext});
   
     
    } catch (error) {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      handleErr("WATCHLISTADD-ERROR");
      focusedIndex = 1;
    setState((prevState) => ({
      ...prevState,
            isLikeSelected: false,
    }));
    }
  };

  const AdddislikeList = async (item) => {
    const userId = localStorage.getItem("profileId");
    try {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      let headers = {
        Langid: "1",
        profileid: userId,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };
      Dislike = "dislike";
       let ShowId = item?.id === undefined ? item.show_id : item.id;
      let postParam = [{ show_id: ShowId, rating: "dislike", is_deleted: 1 }];
      const addlikeDislikeResponse = await addLikeDisLike(postParam, headers);
      setTimeout(() => {
        likeDislike();
      }, 200);
      setState((prevState) => ({
        ...prevState,
        isDislikeSelected: true,
        isWatchNowSelected: false,
        isAddFavoriteSelected: false,
        isLikeSelected: false,
      }));
      focusedIndex = 4;

       // Send Matomo event for Dislike
      sendEventAction({action:"dislike", type:"likeDislike",item:item,sourceContext:sourceContext});


    } catch (error) {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      handleErr("WATCHLISTADD-ERROR");
      focusedIndex = 1;
      setState((prevState) => ({
        ...prevState,
        isLikeSelected: false,
      }));
          }
  };
 
  let userDetails = JSON.parse(localStorage.getItem("user_details"));
  // let userProfile = userDetails?.user_profiles?.[0];
  const subscriptionsArray =
    userDetails?.user_profiles?.[0]?.subscriptions || [];

  const exists =
    Array.isArray(window.PUBLISHERID) &&
    Array.isArray(window.OWNED_BY) &&
    window.PUBLISHERID.some((item) =>
      window.OWNED_BY.includes(item.publisherId)
    );

  const item = itemDetails?.[0] || {};
  const plans =
    typeof item.plans === "string"
      ? item.plans.split(",").map(Number)
      : typeof item.plans === "number"
        ? [item.plans]
        : item.plans;

  const owned =
    typeof item.owned_by === "string"
      ? item.owned_by.split(",").map(Number)
      : typeof item.owned_by === "number"
        ? [item.owned_by]
        : [];

  window.PLANSARRAY = plans;
  window.OWNED_BY = owned;
  window.IS_PAID = item.is_paid;
  

  subscriptionCheck =
    // banneritems[currentIndex].plans !== null
    itemDetails[0]?.plans === null
    ? hasSingleMatch(owned, subscriptionsArray)
      : arraysEquals(window.PLANSIDS, plans);
   function hasSingleMatch(arr1, arr2) {
  return arr1.some(v => arr2.includes(v));
}

window.SUBSCRIPTIONDATA = subscriptionCheck;
console.log("subscriptionCheck....", subscriptionCheck);
 
  let ownedByCheck =
    banneritems[currentIndex].owned_by !== null ? exists : null;

  function arraysEquals(a, b) {
    console.log("arraysEquals called", a, b);

    // Check if both are arrays
    if (!Array.isArray(a) || !Array.isArray(b)) return false;

    // Check if lengths match
    if (a.length !== b.length) return false;

    // Check each element
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    // All elements matched
    return true;
  }

  const BGScreenKeyHandler = (event, index) => {
    if (index) {
      focusedIndex = index;
    }
    console.log("shouldAuthError....d",focusedIndex, shouldAuthError, shouldShowAuthModal);

     if (shouldShowAuthModal) return;
    switch (event.keyCode) {
      case 13:
        isKeyListenerAdded = false; // Reset the flag

        if (focusedIndex === 11||isError) {
          handleBack();
          return;
        }

        if (banneritems[0]?.type === 6 && focusedIndex === 1) {
          console.log("gamestest", "LOGGER");
          shouldFocusToScreenBG = false;
          handleErr("GAME-MESSAGE");
          return;
        }

        if (focusedIndex === 10) {
          window.isStartOverSelectedButton = true; // Set the flag to true
          navigate("VideoScreen", itemDetails[0]);
          // return;
        }
        if (focusedIndex === 9) {
          event.preventDefault(); // Prevent default action
          event.stopPropagation(); // Stop event from bubbling up
          setReadMore((prev) => {
            const newState = !prev;
            sendEvent({action:"Description", isReadMore:newState});
            return newState; // Use function to ensure correct state update
          });
          return;
        }

        if (focusedIndex === 1) {
          if (isLogedIn) {
            focusedIndex = 1;

            // Ensure we have item details
            if (itemDetails.length < 1 && getItemDetails) {
              itemDetails = getItemDetails();
            }

            const currentBannerItem = banneritems[currentIndex];
            const isLiveStream =
              (currentBannerItem.live_date_time > 0 &&
                currentBannerItem.live_end_time === 0 &&
                currentBannerItem.is_live == 1) ||
              currentBannerItem.is_live == 1 ||
              currentBannerItem.still_live == 1;
            const isFreeContent =
              currentBannerItem.live_date_time === 0 ||
              (currentBannerItem.live_date_time == null &&
                currentBannerItem.live_end_time === 0) ||
              (currentBannerItem.live_end_time == null &&
                currentBannerItem.is_live == 0 &&
                currentBannerItem.is_paid == 0 &&
                currentBannerItem.type == 0);
            const isAudioContent =
              currentBannerItem.type === 1 ||
              currentBannerItem.media_type === 1;
            const isPaidContent = currentBannerItem.is_paid == 1;
            const isRentalContent =
              currentBannerItem.is_paid == 2 || currentBannerItem.is_paid === 3;
            const hasPDF =
              currentBannerItem.type === 5 ||
              currentBannerItem.media_type === 5;
            const hasImage =
              currentBannerItem.type === 4 ||
              currentBannerItem.type === 7 ||
              currentBannerItem.media_type === 4 ||
              currentBannerItem.media_type === 7;

            const isTeaserLaunch = currentBannerItem.isTeaser === 1;
            const adsFreeContent = currentBannerItem.is_paid === 4;
            const normalContent =
              currentBannerItem &&
              currentBannerItem.length > 0 &&
              currentBannerItem !== undefined &&
              !isAudioContent;

            if (isTeaserLaunch) return;

            // Clean up event listeners first
            shouldFocusToScreenBG = false;
            window.removeEventListener("keydown", BGScreenKeyHandler);

            if (
              banneritems[currentIndex].live_date_time > 0 &&
              banneritems[currentIndex].live_end_time === 0 &&
              banneritems[currentIndex].is_live !== 1
            ) {
              let tmr = setTimeout(function () {
                clearTimeout(tmr);
                window.removeEventListener("keydown", BGScreenKeyHandler);
                window.addEventListener("keydown", BGScreenKeyHandler);
              }, 500);
              return;
            }

            // Handle navigation based on content type
            else if (
              (isLiveStream ||
                isFreeContent ||
                currentBannerItem.is_live == 2) &&
              !hasPDF &&
              !hasImage &&
              !isAudioContent &&
              !isRentalContent &&
              !isPaidContent
            ) {
              navigate("VideoScreen", itemDetails[0] || currentBannerItem);
            } else if (isAudioContent) {
              console.log("Navigating to AudioPlayer for audio content");
              navigate("AudioPlayer", itemDetails[0] || currentBannerItem);
            } else if (hasPDF && !isAudioContent) {
              console.log("Navigating to PDFViewer");
              navigate("PDFViewer", itemDetails[0]);
            } else if (hasImage && !isAudioContent) {
              console.log("Navigating to ImageViewer", itemDetails[0]);
              navigate("PDFViewer", itemDetails[0]);
            } else if (isPaidContent && !isAudioContent) {
              if (subscriptionCheck) {
                console.log(
                  "Navigating to VideoScreen for paid content (subscribed)"
                );
                navigate("VideoScreen", itemDetails[0]);
              } else {
                console.log("Showing subscribe message", subscriptionCheck);
                handleErr("SUBSCRIBE-MESSAGE");
              }
            } else if (isRentalContent && !isAudioContent) {
              if (window.IS_ON_RENT === 1) {
                console.log(
                  "Navigating to VideoScreen for other content types"
                );
                navigate("VideoScreen", itemDetails[0]);
              } else {
                console.log("Showing rental message");
                handleErr("RENTAL-MESSAGE");
              }
            } else if (normalContent && !isAudioContent) {
              console.log("Navigating to VideoScreen for other content types");
              navigate("VideoScreen", itemDetails[0]);
            }
            else if (
              itemDetails &&
              itemDetails.length > 0 &&
              itemDetails[0] !== undefined &&
              !isAudioContent
            ) {
              console.log("Default navigation to VideoScreen");
              navigate("VideoScreen", itemDetails[0]);
            } else if (currentBannerItem.file_url && !isAudioContent) {
              console.log("Navigating to VideoScreen using banner item");
              navigate("VideoScreen", currentBannerItem);
            } else if (adsFreeContent) {
              console.log("Navigating to VideoScreen using banner item");
              navigate("VideoScreen", currentBannerItem);
            } else if (!isAudioContent) {
              console.log("Navigation to videoscreen.....");
              navigate("VideoScreen", itemDetails[0]);
            }
          }
        }

        else if (focusedIndex === 2) {
          console.log("add to watchlist....", itemDetails);
          if (isLogedIn) {
            let selectedItem1 =
              itemDetails &&
                itemDetails.length > 0 &&
                itemDetails[0] !== undefined
                ? itemDetails[0]
                : banneritems[currentIndex];
            console.log("selectedItem1...", selectedItem1);
            if (selectedItem1.still_live === 1) {
              AddToFavourite(selectedItem1);
            } else {
              AddDelWatchList(selectedItem1);
            }
          } else {
            console.log("4444444");
            focusedIndex = 2;
            shouldFocusToScreenBG = false;
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            window.removeEventListener("keydown", BGScreenKeyHandler);
            isKeyListenerAdded = false;
            handleErr("NOT-AUTHENTICATED");
          }
        } else if (focusedIndex === 3) {
          if (isLogedIn) {
            let selectedItem1 =
              itemDetails &&
                itemDetails.length > 0 &&
                itemDetails[0] !== undefined
                ? itemDetails[0]
                : banneritems[currentIndex];
            AddlikeList(selectedItem1);
          } else {
            focusedIndex = 3;
            shouldFocusToScreenBG = false;
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            window.removeEventListener("keydown", BGScreenKeyHandler);
            isKeyListenerAdded = false;
            handleErr("NOT-AUTHENTICATED");
          }
        } else if (focusedIndex === 4) {
          // //console.log("focusedIndex...", focusedIndex);
          if (isLogedIn) {
            let selectedItem1 =
              itemDetails &&
                itemDetails.length > 0 &&
                itemDetails[0] !== undefined
                ? itemDetails[0]
                : banneritems[currentIndex];
            AdddislikeList(selectedItem1);
          } else {
            focusedIndex = 4;
            shouldFocusToScreenBG = false;
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            window.removeEventListener("keydown", BGScreenKeyHandler);
            isKeyListenerAdded = false;
            handleErr("NOT-AUTHENTICATED");
          }
        } else if (focusedIndex === 14) {
          console.log("alarm....enter...set....");
          focusedIndex = 14;
          shouldFocusToScreenBG = false;
          setState((prevState) => ({
            ...prevState,
            isWatchNowSelected: true,
            isAddFavoriteSelected: false,
            isLikeSelected: false,
            isDislikeSelected: false,
            isBelliconSelected: false,
          }));
          window.removeEventListener("keydown", BGScreenKeyHandler);
          isKeyListenerAdded = false;
          handleErr("GET-REMINDER");
          sendTestMatomoEvent({ eventCategory: "RemindMePopup", eventAction: "Select", eventName: `ComingSoon/${itemDetails[0]?.id}/${itemDetails[0]?.title}(Disable)` });

        }
        setState((prevState) => ({
          ...prevState,
          isCastCreSelected: false,
          isSimilarSelected: false,
        }));

        break;

      case 38: // Up Arrow
        console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
        if(isError){
          return;
        }
        if (isDetails) {
          if (
            focusedIndex === 1 ||
            focusedIndex === 2 ||
            focusedIndex === 3 ||
            focusedIndex === 4
          ) {
            if (itemDetails[0]?.description[0]?.content.length > 200 ||banneritems[currentIndex]?.description[0]?.content.length > 200) {
              console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
              setState((prevState) => ({
                ...prevState,
                isReadMoreSelected: true,
                isBackButtonSelected: false,
                isWatchNowSelected: false,
                isAddFavoriteSelected: false,
                isLikeSelected: false,
                isDislikeSelected: false,
                isCastCreSelected: false,
                isSimilarSelected: false,
                isEpisodeSelected: false,
              }));
              console.log("focusedIndex//", focusedIndex);
              focusedIndex = 9;
              return;
            } else {
              console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
              setState((prevState) => ({
                ...prevState,
                isReadMoreSelected: false,
                isBackButtonSelected: true,
                isWatchNowSelected: false,
                isAddFavoriteSelected: false,
                isLikeSelected: false,
                isDislikeSelected: false,
                isCastCreSelected: false,
                isSimilarSelected: false,
                isEpisodeSelected: false,
              }));
              focusedIndex = 11;
            }
          }

          if (focusedIndex === 9) {
            console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
            console.log("focusedIndex//", focusedIndex);
            setState((prevState) => ({
              ...prevState,
              isReadMoreSelected: false,
              isBackButtonSelected: true,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isCastCreSelected: false,
              isSimilarSelected: false,
              isEpisodeSelected: false,
            }));
            focusedIndex = 11;
            return;
          }

          if (focusedIndex === 5 || focusedIndex === 6 || focusedIndex === 7) {
            console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
            console.log("Up btn ------- focusIndx = ", focusedIndex);
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: true,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isCastCreSelected: isSeries ? false : true,
              isSimilarSelected: false,
              isEpisodeSelected: isSeries ? true : false,
              // Reset MarkupGrid properties for episodes view
              itemComponentName: "EpisodesWidget",
              selectedItemId: "episodes",
              TabContent: Episodes.length > 0 ? Episodes[0].episodes : [],
              shouldshowSeasonRowlist: true,
              episodeMarginTop: "265px",
            }));
            focusedIndex = 1;
          }
        } else {
          console.log("Up btn ------- focusIndx = ", focusedIndex, isDetails);
          console.log("enter up button...");
          handleBackButton();
        }
        break;
      case 39: // Right Arrow
        console.log("Right btn ------- focusIndx = ", focusedIndex);
        if (focusedIndex === -2) {
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
            isWatchNowSelected: true,
          }));

          focusedIndex = 1;
        } else if (focusedIndex === 1 && !isLiveEvent && !isLiveScreen) {
          if (banneritems[0]?.paused_at >= 0) {
            setState((prevState) => ({
              ...prevState,
              isStartOverSelected: true,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
            }));
            focusedIndex = 10;
            break;
          }
          if (banneritems[0]?.isTeaser === 1) {
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isBelliconSelected: true,
            }));
            focusedIndex = 14;
            break;
          } else {
            setState((prevState) => ({
              ...prevState,
              isStartOverSelected: false,
              isWatchNowSelected: false,
              isAddFavoriteSelected: true,
            }));
            focusedIndex = 2;
            break;
          }
        } else if (focusedIndex === 1 && isLiveEvent && isLiveScreen) {
          console.log("333333333333333333.........");
          setState((prevState) => ({
            ...prevState,
            isAddFavoriteSelected: false,
            isWatchNowSelected: true,
          }));
          // focusedIndex += 1;
          break;
        } else if (focusedIndex === 10 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isStartOverSelected: false,
            isAddFavoriteSelected: true,
            isLikeSelected: false,
          }));
          focusedIndex = 2;
          break;
        } else if (focusedIndex === 2 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isAddFavoriteSelected: false,
            isLikeSelected: true,
          }));
          focusedIndex += 1;
          break;
        } else if (focusedIndex === 3 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isLikeSelected: false,
            isDislikeSelected: true,
          }));
          focusedIndex += 1;
          break;
        } else if (focusedIndex === 14 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isBelliconSelected: false,
            isLikeSelected: true,
          }));
          focusedIndex = 3;
          sendEvent({action:"RemindMePopup",itemDetails:item});
          break;
        } else if (focusedIndex === 5 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isEpisodeSelected: false,
            isCastCreSelected: true,
          //  selectedItemId: "castcrew",
          }));
          focusedIndex += 1;
          break;
        } else if (
          focusedIndex === 6 &&
          isSeries &&
          !isLiveEvent &&
          !isLiveScreen
        ) {
          setState((prevState) => ({
            ...prevState,
            isCastCreSelected: false,
            isSimilarSelected: true,
          //  selectedItemId: "similaritems",
          }));
          focusedIndex += 1;
          break;
        }
        if (!isLiveEvent) {
          setIsNavigating(true);
          handleNavigationComplete();
        }
        break;
      case 37: // Left Arrow
        if (focusedIndex === 4 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isWatchNowSelected: false,
            isAddFavoriteSelected: false,
            isLikeSelected: true,
            isDislikeSelected: false,
          }));
          focusedIndex = 3;
        } else if (focusedIndex === 3 && !isLiveEvent && !isLiveScreen) {
          if (banneritems[0].isTeaser === 1) {
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isBelliconSelected: true,
            }));
            focusedIndex = 14;
          } else {
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: true,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            focusedIndex = 2;
          }
        } else if (focusedIndex === 2 && !isLiveEvent) {
          if (banneritems[0]?.paused_at >= 0) {
            setState((prevState) => ({
              ...prevState,
              isStartOverSelected: true,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            focusedIndex = 10;
            break;
          } else {
            setState((prevState) => ({
              ...prevState,
              isStartOverSelected: false,
              isWatchNowSelected: true,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
            }));
            focusedIndex = 1;
            break;
          }
        } else if (focusedIndex === 10 && !isLiveEvent) {
          setState((prevState) => ({
            ...prevState,
            isStartOverSelected: false,
            isWatchNowSelected: true,
            isAddFavoriteSelected: false,
            isLikeSelected: false,
            isDislikeSelected: false,
          }));
          focusedIndex = 1;
          break;
        } else if (focusedIndex === 14 && !isLiveEvent) {
          setState((prevState) => ({
            ...prevState,
            isStartOverSelected: false,
            isWatchNowSelected: true,
            isAddFavoriteSelected: false,
            isLikeSelected: false,
            isDislikeSelected: false,
            isBackButtonSelected: false,
            isBelliconSelected: false,
          }));
          focusedIndex = 1;
          break;
        } else if (
          focusedIndex === 6 &&
          !isSeries &&
          !isLiveEvent &&
          !isLiveScreen
        ) {
          setState((prevState) => ({
            ...prevState,
            isCastCreSelected: true,
         //   selectedItemId: "castcrew",
            isSimilarSelected: false,
          }));
          focusedIndex = 5;
        } else if (
          focusedIndex === 6 &&
          isSeries &&
          !isLiveEvent &&
          !isLiveScreen
        ) {
          setState((prevState) => ({
            ...prevState,
            isEpisodeSelected: true,
        //    selectedItemId: "episodes",
            isCastCreSelected: false,
          }));
          focusedIndex = 5;
        } else if (focusedIndex === 7 && !isLiveEvent && !isLiveScreen) {
          setState((prevState) => ({
            ...prevState,
            isCastCreSelected: true,
           // selectedItemId: "castcrew",
            isSimilarSelected: false,
          }));
          focusedIndex = 6;
        }
        if (!isLiveEvent && !isLiveScreen) {
          setIsNavigating(true);
          handleNavigationComplete();
        }
        break;
      case 40: // Down Arrow
  if(isError){
        return;
      }
      console.log("focusedIndex...", focusedIndex);
        if (focusedIndex === -2) {
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
            isReadMoreSelected: true,
          }));
          focusedIndex = 9;
          return;
        }

        if (focusedIndex === 9) {
          setState((prevState) => ({
            ...prevState,
            isReadMoreSelected: false,
            isWatchNowSelected: true,
          }));
          focusedIndex = 1;
          return;
        }

        if (focusedIndex === 11) {
          if (itemDetails[0]?.description[0]?.content.length > 200  ||banneritems[currentIndex]?.description[0]?.content.length > 200) {
            setState((prevState) => ({
              ...prevState,
              isReadMoreSelected: true,
              isBackButtonSelected: false,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isCastCreSelected: false,
              isSimilarSelected: false,
              isEpisodeSelected: false,
            }));
            focusedIndex = 9;
            return;
          } else {
            setState((prevState) => ({
              ...prevState,
              isReadMoreSelected: false,
              isBackButtonSelected: false,
              isWatchNowSelected: true,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isCastCreSelected: false,
              isSimilarSelected: false,
              isEpisodeSelected: false,
            }));
            focusedIndex = 1;
            return;
          }
        }

        if (focusedIndex === 11) {
          console.log("focusedIndex//", focusedIndex);
          setState((prevState) => ({
            ...prevState,
            isReadMoreSelected: true,
            isBackButtonSelected: false,
            isWatchNowSelected: false,
            isAddFavoriteSelected: false,
            isLikeSelected: false,
            isDislikeSelected: false,
            isCastCreSelected: false,
            isSimilarSelected: false,
            isEpisodeSelected: false,
          }));
          focusedIndex = 9;
          return;
        }

        if (Episodes.length <= 0 && artist.length <= 0 && similar.length <= 0) {
          return;
        }

        if(isDetails &&( focusedIndex === 1 || focusedIndex === 2 || focusedIndex === 3 || focusedIndex === 4 || focusedIndex === 10)){
          //  if (isDetails && (Episodes.length > 0 || artist.length > 0 || similar.length > 0)) {
          window.removeEventListener("keydown", BGScreenKeyHandler);
          flg = true;
          focusedIndex = 5;

          if (Episodes.length > 0) {
            // Agar episodes hain, to episode grid dikhayein
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isEpisodeSelected: true,
              isCastCreSelected: false,
              isSeries: true,
              shoulddetailsOpen: flg,
              TabContent: Episodes[0].episodes,
              shouldshowSeasonRowlist: true,
              episodeMarginTop: "265px", // Episodes ke liye default margin
              selectedItemId: "episodes",
            }));
          } else if (artist.length > 0) {
            // Agar episodes nahi hain, par cast hai, to cast & crew grid dikhayein
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isEpisodeSelected: false,
              isCastCreSelected: true,
              shoulddetailsOpen: flg,
              TabContent: artist,
              shouldshowSeasonRowlist: false,
              episodeMarginTop: "165px", // Cast & Crew ke liye kam margin
              selectedItemId: "castcrew",
            }));
          } else if (similar.length > 0) {
            // Fallback: Agar kuch nahi hai to similar items dikhayein
            setState((prevState) => ({
              ...prevState,
              isWatchNowSelected: false,
              isAddFavoriteSelected: false,
              isLikeSelected: false,
              isDislikeSelected: false,
              isSimilarSelected: true,
              shoulddetailsOpen: flg,
              TabContent: similar,
              shouldshowSeasonRowlist: false,
              episodeMarginTop: "165px",
              selectedItemId: "similaritems",
            }));
          }
        }
        break;
      case 10009:
        if ((isDetails && !flg && !isLiveEvent) || isLiveEvent) {
          setState((prevState) => ({
            ...prevState,
            isWatchNowSelected: false,
            isMoreInfoSelected: false,
            isAddFavoriteSelected: false,
            isLikeSelected: false,
            isDislikeSelected: false,
            isSeries: false,
            isEpisodeSelected: false,
            isCastCreSelected: false,
            isSimilarSelected: false,
            TabContent: [],
            shouldFocusGrid: false,
            shouldFocusToRowList: false,
            shouldFocusToSeasonRowList: false,
            shouldFocusToEpisodeGrid: false,
            // shoulddetailsOpen: false,
            shouldshowSeasonRowlist: false,
          }));
          setCurrentIndex(0);
          window.removeEventListener("keydown", BGScreenKeyHandler);
          isKeyListenerAdded = false; // Reset the flag
          focusedIndex = 1;
          callBack("HomeScreen");
        } else if (isDetails && flg && !isLiveEvent) {
          console.log("backkey....11111.33333333333..");
          focusedIndex = 1;
          flg = false;
          setCurrentIndex(0);
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
            isWatchNowSelected: true,
            // shoulddetailsOpen: false,
            TabContent:
              Episodes.length > 0
                ? Episodes[0].episodes
                : artist.length > 0 && similar.length <= 0
                  ? artist
                  : Episodes.length <= 0 &&
                    artist.length <= 0 &&
                    similar.length > 0
                    ? similar
                    : [],
            isEpisodeSelected: Episodes.length > 0 ? true : false,
            isCastCreSelected:
              Episodes.length <= 0 && artist.length > 0 && similar.length <= 0
                ? true
                : false,
            isSimilarSelected:
              Episodes.length <= 0 && artist.length <= 0 && similar.length > 0
                ? true
                : false,
          }));
        }
        break;
      case 10009:
      case 461:
      case 8: // Back key
        handleBack();
        break;
      default:
        break;
    }
  };

  function handleBack() {
    console.log(
      "window.videoSettings, window.videoLanguages...",
      window.videoSettings,
      window.videoLanguage
    );

  // -----------------------------------------------
  // 1. Highest priority: Close video/settings layer
  // -----------------------------------------------
  if (window.videoSettings || window.videoLanguage) {
    window.videoSettings = false;
    window.videoLanguage = false;
    return;
  }

  // ----------------------------------------------------
  // 2. Close FULL DETAIL SCREEN (live or non-live)
  // ----------------------------------------------------
    if ((isDetails && !flg && !isLiveEvent) || isLiveEvent) {
      setState((prevState) => ({
        ...prevState,
        shoulddetailsOpen:false,
        isWatchNowSelected: false,
        isMoreInfoSelected: false,
        isAddFavoriteSelected: false,
        isLikeSelected: false,
        isDislikeSelected: false,
        isSeries: false,
        isEpisodeSelected: false,
        isCastCreSelected: false,
        isSimilarSelected: false,
        TabContent: [],
        shouldFocusGrid: false,
        shouldFocusToRowList: false,
        shouldFocusToSeasonRowList: false,
        shouldFocusToEpisodeGrid: false,
        shouldshowSeasonRowlist: false,
        isBackButtonSelected: false,
        isError: false,
      }));

      setCurrentIndex(0);

      window.removeEventListener("keydown", BGScreenKeyHandler);
    isKeyListenerAdded = false;

      focusedIndex = 1;
      callBack("HomeScreen");
    } else if (isDetails && flg && !isLiveEvent) {
      console.log("backkey....closing details grid..");

      focusedIndex = 1;
      flg = false;

    // Re-attach key listener
      setTimeout(function () {
        isKeyListenerAdded = false;
        addKeyListener();
      }, 200);

    // Build default tab state
      let defaultTabState = {};

      if (Episodes.length > 0) {
        defaultTabState = {
          isEpisodeSelected: true,
          isCastCreSelected: false,
          isSimilarSelected: false,
          shoulddetailsOpen: false,
          selectedItemId: "episodes",
          itemComponentName: "EpisodesWidget",
          TabContent: Episodes[0].episodes,
          shouldshowSeasonRowlist: true,
          episodeMarginTop: "265px",
        };
      } else if (artist.length > 0) {
        defaultTabState = {
          isEpisodeSelected: false,
          isCastCreSelected: true,
          isSimilarSelected: false,
          shoulddetailsOpen: false,
          selectedItemId: "castcrew",
          TabContent: artist,
          shouldshowSeasonRowlist: false,
          episodeMarginTop: "165px",
        };
      } else if (similar.length > 0) {
        defaultTabState = {
          isEpisodeSelected: false,
          isCastCreSelected: false,
          isSimilarSelected: true,
          shoulddetailsOpen: false,
          selectedItemId: "similaritems",
          TabContent: similar,
          shouldshowSeasonRowlist: false,
          episodeMarginTop: "165px",
        };
      }

    // Apply updated state
      setState((prevState) => ({
        ...prevState,
      isWatchNowSelected: true,
      shoulddetailsOpen: false,
      ...defaultTabState,
        shouldFocusToRowList: true,
        shouldFocusToSeasonRowList: false,
        shouldFocusToEpisodeGrid: false,
      }));
    }
    if (window.videoSettings || window.videoLanguage) {
      window.videoSettings = false;
      window.videoLanguage = false;
      return;
    }
  }

  const checkAddedComing = async (data) => {
    console.log("checkAddedComing...", data);
    if (!data[0]?.id) return;

    try {
      const profile_id = localStorage.getItem("profileId");
      const userId = localStorage.getItem("userId");
      const showId = data[0].id;
      const response = await getComingSoon(userId, showId);
      const status = response?.data?.reminder_status || 0;
      window.REMINDER_STATUS = status;
    } catch (error) {
      console.error("Error checking reminder status:", error);
    }
  };

  function formatUnixToDate(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000); // Convert Unix timestamp to milliseconds

    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    const ordinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th"; // Covers 11th to 19th
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const dayWithSuffix = `${day}${ordinalSuffix(day)}`;

    return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  function isTimeExpired(unixTimestamp) {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in Unix (seconds)
    return currentTime > unixTimestamp;
  }

  const handleNavigationComplete = () => {
    setIsNavigating(false);
  };

  const handleTabSelect = (selectedIndex) => { };

  const styles = {
    ScreenBGItemContainer: {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100vw",
      backgroundImage: `url(${solidbackgroundimg})`,
      height: "100vh",
      overflow: "hidden",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: "0",
      left: "0",
    },
    shadowLayer: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      display: "block",
    },
  };

  const callback = (event) => { };

  const handleMarkupGridBack = () => {
    console.log("handleMarkupGridBack");
    let keyEvent = {
      isTrusted: true,
      code: "ArrowDown",
      key: "ArrowDown",
      keyCode: 8,
      type: "keydown",
    };
    BGScreenKeyHandler(keyEvent);
    setTimeout(function () {
      isKeyListenerAdded = false;
      addKeyListener();
    }, 200);
  };

  function handleClick(e, index) {
    console.log("handleClick", e, index);
    const keyEvent = {
      isTrusted: true,
      code: "Enter",
      key: "Enter",
      keyCode: e || 13,
      type: "keydown",
    };
    BGScreenKeyHandler(keyEvent, index);
  }

  const renderContent = (items) =>
    items.map(
      (item, index) => (
        console.log("item for normal content....", item),
        console.log(
          "renderContent",
          item,
          index,
          currentIndex,
          isLiveScreen,
          isLiveEvent
        ),
        (
          <div key={item.id}>
            {isLiveScreen ? (
              <img
                id={item.id ? item.id : 0}
                src={item.poster_url ? item.poster_url : item.detail_banner}
                alt={item.title ? item.title : ""}
                className="carousel-image"
                style={{
                  ...styles.image,
                  opacity: index === currentIndex ? 1 : 0,
                  transition: "opacity 1s", // Smooth fade transition
                }}
              />
            ) : (
              (item.banner_url || item.detail_banner) && (
                <img
                  id={item.id ? item.id : 0}
                  src={item.banner_url ? item.banner_url : item.detail_banner}
                  alt={item.title ? item.title : ""}
                  className="carousel-image"
                  style={{
                    ...styles.image,
                    opacity: index === currentIndex ? 1 : 0,
                    transition: "opacity 1s", // Smooth fade transition
                  }}
                />
              )
            )}

            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            >
              <img
                src={ShadowLayer}
                alt="Shadow Layer"
                style={styles.shadowLayer}
              />
            </div>
            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
                fontWeight: "bold",
                fontSize: resolution === "FHD" ? "40px" : "27px",
                color: "#F1F1F1",
                position: "absolute",
                width: "100%",
                height: resolution === "FHD" ? "138px" : "92px",
                marginTop: "10rem",
                marginLeft: "7.1rem",
                background: "transparent",
                display: "flex",
                alignItems: "end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "-3rem",
                  marginLeft: "0.2rem",
                  gap: "0.2rem",
                }}
              >
                {item.banner_icon ? (
                  <img
                    src={item.banner_icon}
                    height={resolution === "FHD" ? "138px" : "92px"}
                    alt="Placeholder"
                    style={{
                      objectFit: "contain",
                      objectPosition: "left",
                      borderRadius: "0.5rem",
                      height: "12rem",
                      width: "auto",
                      marginBottom: "1rem",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "3rem",
                      lineHeight: "1",
                      textTransform: "uppercase",
                    }}
                  >
                    {console.log(
                      item,
                      banneritems,
                      itemDetails[0]?.partner_image_detail_page,
                      itemDetails[0]?.publisher_logo,
                      "CheckTItle"
                    )}
                    {itemDetails[0]?.partner_image_detail_page != null ? (
                      <img
                        style={{ width: "10%" }}
                        src={itemDetails[0]?.partner_image_detail_page}
                      />
                    ) : (
                      <img
                        style={{ width: "10%" }}
                        src={itemDetails[0]?.publisher_logo}
                      />
                    )}
                    <p>{item?.title}</p>
                  </div>
                )}
                <div
                  style={{
                    fontSize: "28px",
                    color: "white",
                  }}
                >
                  {item?.skip_season == 0 && (
                    <>
                      {item?.season_count}{" "}
                      {item?.season_count > 1 ? "Seasons" : "Season"} <img
                        src={dotIcon}
                        style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}

                      />
                    </>
                  )}
                  {item.video_time !== 0 && item.skip_season == 1 && (
                    <>
                      {formatTime(item.video_time)}
                      {(item.language_title ||
                        item.agency ||
                        item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        <img
                          src={dotIcon}
                          style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}
                        />}
                    </>
                  )}
                  {console.log("item.language_title...", item?.language_title)}
                  {item?.language_title && (
                    <>
                      {item?.language_title}
                      {(item.agency ||
                        item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        <img
                          src={dotIcon}
                          style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}
                        />}
                    </>
                  )}
                  {item.agency && (
                    <>
                      {item.agency}
                      {(item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        <img
                          src={dotIcon}
                          style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}
                        />}
                    </>
                  )}
                  {item.certificate && item?.age>0  && (
                    <>
                      {item.certificate}
                      {item.rating_json && item.rating_json[0]?.rating && " . "}
                      {item.age&&<span>&nbsp;{item?.age}+</span>}
                    </>
                  )}
                  {console.log("item.rating_json...", item?.rating_json)}
                  {item?.rating_json && item?.rating_json?.[0]?.rating && (
                    <span style={{ position: "relative", top: "10px" }}>
                      <img src={idmdimg} alt="Rating" />
                      <span style={{ position: "relative", top: "-8px" }}>
                        &nbsp;{item?.rating_json?.[0]?.rating}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div
              className="carousel-image"
              style={{
                opacity: 1,
                transition: "opacity 1s",
                color: "rgb(201, 206, 221)",
                fontSize: resolution === "FHD" ? "30px" : "20px",
                position: "absolute",
                width: readMore ? "80%" : "90vh",
                height: "15vh",
                marginTop: "23rem",
                marginLeft: resolution === "FHD" ? "7.5rem" : "5rem", // Converted 118px to rem
                background: "transparent",
                overflow: "hidden",
                textOverflow: "ellipsis",
                zIndex: shoulddetailsOpen ? "0" : "1",
              }}
            >
              {item?.description &&
                item?.description?.find((item) => item?.language)
                ? item?.description?.find(
                  (item) =>
                    item.language === localStorage.getItem("AppLanguage")
                )
                  ? 
                    truncateText(
                      item?.description?.find(
                        (item) =>
                          item.language ===
                          localStorage.getItem("AppLanguage")
                      )?.content
                    )
                  
                  : 
                    truncateText(item?.description?.[0]?.content)
                  
                : ""}

              {item?.description?.[0]?.content !== "" &&
                item?.description?.[0]?.content.split(" ").length > 15 &&
                // banneritems[currentIndex]?.playlist_type !== "upcoming" &&
                item?.description?.[0]?.content.length > 200 ? (
                <span
                  tabIndex={0}
                  style={{
                    color:
                    focusedIndex === 9 || isHovered ? "#EC008C" : "#fff",
                    display: "inline-block",
                    marginLeft: "10px",
                  }}

                  onClick={(e) => {
                    if (item?.description[0]?.content.length > 200)
                      setReadMore((prev) => !prev);
                  }}
                >
                  {!readMore ? (
                    <Translate langKey={"view_more"} />
                  ) : (
                    <Translate langKey={"view_less"} />
                  )}
                </span>

              ) : (
                ""
              )}
            </div>

            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
                position: "absolute",
                width: "35vw",
                height: "6vh",
                marginTop: "38rem",
                marginLeft: "4vw",
                marginLeft: "2.5vw",
                background: "transparent",
              }}
            >
              {item?.genres !== undefined && item?.genres !== null
                ?
                (() => {
                  const genres = item?.genres
                    .split(",")
                    .slice(0, 3)
                    .filter(Boolean); // take up to 3 non-empty genres

                  return (
                    <p
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "4.5rem",
                        marginTop: "-8rem",
                        position: "absolute",
                        height: "2vh",
                        borderRadius: "0px",
                        background: "transparent",
                        color: "rgb(137, 150, 185)",
                        display: "inline-flex",
                        fontSize: resolution === "FHD" ? "1.4rem" : "1.2rem",
                      }}
                    >
                      {genres.join(" | ")}
                    </p>
                  );
                })()
                : null}
            </div>
            <div style={{ display: isDetails ? "none" : "flex" }}>
              <CustomButton
                navigateTo="/login"
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={isWatchNowSelected}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "53vh" : "53vh"}
                onClick={(e) => {
                  handleClick(null, 1);
                }}
                className="carousel-image"
                style={{
                  opacity: index === currentIndex ? 1 : 0,
                  transition: "opacity 1s",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <img
                  src={playIcon}
                  style={{
                    width: resolution === "FHD" ? "26px" : "18px",
                    height: resolution === "FHD" ? "31px" : "22px",
                    marginLeft: resolution === "FHD" ? "-180px" : "-110px",
                    marginTop: resolution === "FHD" ? "5px" : "2px",
                  }}
                  alt="Play Button"
                />
                <span
                  style={{
                    marginLeft: resolution === "FHD" ? "27px" : "18px",
                    marginTop: resolution === "FHD" ? "5px" : "3px",
                  }}
                >
                  <Translate langKey={"Watchnow"} />
                </span>
              </CustomButton>
              <CustomButton
                navigateTo="/login"
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={isMoreInfoSelected}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "53vh" : "53vh"}
                onClick={(e) => {
                  handleClick(null, 1);
                }}
                className="carousel-image"
                style={{
                  opacity: index === currentIndex ? 1 : 0,
                  transition: "opacity 1s",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <img
                  src="./assets/noticon.png"
                  style={{
                    width: resolution === "FHD" ? "26px" : "18px",
                    height: resolution === "FHD" ? "31px" : "22px",
                    marginLeft: resolution === "FHD" ? "-160px" : "-100px",
                    marginTop: resolution === "FHD" ? "5px" : "2px",
                  }}
                  alt="More Info Button"
                />
                <span
                  style={{
                    position: "absolute",
                    marginLeft: resolution === "FHD" ? "27px" : "18px",
                    marginTop: resolution === "FHD" ? "5px" : "3px",
                  }}
                >
                  More info
                </span>
              </CustomButton>
            </div>

            <div
              style={{
                display: isDetails ? "flex" : "none",
                position: "absolute",
                left: "11vh",
                gap: "1rem",
              }}
            >
              <div style={{ display: "flex", gap: "1rem" }}>
                {itemDetails[0]?.is_paid === 1 && !subscriptionCheck ? (
                  <CustomButton
                    isLiveText={
                      banneritems[0]?.is_live === 0 &&
                      banneritems[0]?.live_date_time > 1
                    }
                    navigateTo="/login"
                    fontSize={resolution === "FHD" ? "26px" : "18px"}
                    defaultSelected={isWatchNowSelected}
                    // width={resolution === "FHD" ? "254px" : "169px"}
                    height={resolution === "FHD" ? "80px" : "53px"}
                    top="50vh"
                    // left={resolution === "FHD" ? "118px" : "80px"}
                    onClick={(e) => {
                      handleClick(null, 1);
                    }}
                    className="carousel-image"
                    display="flex"
                    alignItems="center"
                    style={{
                      opacity: index === currentIndex ? 1 : 0,
                      transition: "opacity 1s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                      fontWeight: "bold",
                    }}
                    IsSubscribe={true}
                  >
                    <img
                      src={playIcon}
                      style={{
                        width: resolution === "FHD" ? "26px" : "18px",
                        height: resolution === "FHD" ? "31px" : "22px",
                        marginRight: "14px",
                      }}
                      alt="Play Button"
                    />
                    <p><Translate langKey={"Subscribe to watch"} /></p>
                  </CustomButton>
                ) : itemDetails[0]?.is_paid === 2 ||
                  itemDetails[0]?.is_paid === 3 ? (
                  <CustomButton
                    isLiveText={
                      banneritems[0]?.is_live === 0 &&
                      banneritems[0]?.live_date_time > 1
                    }
                    navigateTo="/login"
                    fontSize={resolution === "FHD" ? "26px" : "18px"}
                    defaultSelected={isWatchNowSelected}
                    height={resolution === "FHD" ? "80px" : "53px"}
                    top="50vh"
                    className="carousel-image"
                    style={{
                      opacity: index === currentIndex ? 1 : 0,
                      transition: "opacity 1s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.8rem",
                      fontWeight: "bold",
                      fontSize: "32px",
                    }}
                    onClick={(e) => {
                      handleClick(null, 1);
                    }}
                    widthSubscribe={true}
                  >
                    {window.IS_ON_RENT !== 1 ? (
                      "")
                      : (<img
                        src={playIcon}
                        style={{
                          width: resolution === "FHD" ? "26px" : "18px",
                          height: resolution === "FHD" ? "31px" : "22px",
                          marginRight: "14px",
                        }}
                        alt="Play Button"
                      />)}
                    {window.IS_ON_RENT !== 1 ? (
                      <>
                        <Translate langKey={"availableOnRent"} /> ₹
                        {itemDetails[0]?.pricing?.s_price +
                          itemDetails[0]?.pricing?.gst_amount}
                      </>
                    ) : (
                      <Translate langKey={"Watchnow"} />
                    )}
                  </CustomButton>
                ) : itemDetails[0]?.type === 6 ? (
                  <CustomButton
                    isLiveText={
                      banneritems[0]?.is_live === 0 &&
                      banneritems[0]?.live_date_time > 1
                    }
                    navigateTo="/login"
                    fontSize={resolution === "FHD" ? "26px" : "18px"}
                    defaultSelected={isWatchNowSelected}
                    height={resolution === "FHD" ? "80px" : "53px"}
                    top="50vh"
                    onClick={(e) => {
                      handleClick(null, 1);
                    }}
                    className="carousel-image"
                    style={{
                      opacity: index === currentIndex ? 1 : 0,
                      transition: "opacity 1s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      {banneritems[0]?.live_date_time &&
                        banneritems[0]?.live_end_time > 1 ? (
                        <img
                          style={{
                            width: resolution === "FHD" ? "26px" : "18px",
                            height: resolution === "FHD" ? "31px" : "22px",
                          }}
                          alt="Play Button"
                        />
                      ) : banneritems[0]?.live_date_time === 0 &&
                        banneritems[0]?.live_end_time === 0 ? (
                        <img
                          src={playIcon}
                          style={{
                            width: resolution === "FHD" ? "26px" : "18px",
                            height: resolution === "FHD" ? "31px" : "22px",
                            display:
                              banneritems[0]?.is_live === 0 &&
                                banneritems[0]?.live_date_time &&
                                !isTimeExpired(banneritems[0]?.live_date_time)
                                ? "none"
                                : "inline",
                          }}
                          alt="Play Button"
                        />
                      ) : null}
                    </div>
                    <div>
                      {banneritems[0]?.type == 1 ? (
                        <Translate langKey={"ListenToWatch"} />
                      ) : banneritems[0]?.is_live === 0 ? (
                        banneritems[0]?.live_date_time ? (
                          isTimeExpired(banneritems[0]?.live_date_time) ? (
                            // "Watch since"
                            `Watch since ${formatUnixToDate(
                              banneritems[0]?.live_date_time
                            )}`
                          ) : (
                            `Begins on ${formatUnixToDate(
                              banneritems[0]?.live_date_time
                            )}`
                          )
                        ) : (
                          <Translate langKey={"HowToPlay"} />
                        )
                      ) : (
                        <Translate langKey={"HowToPlay"} />
                      )}
                    </div>
                  </CustomButton>
                ) : (
                  <CustomButton
                    isLiveText={
                      banneritems[0]?.is_live === 0 &&
                      banneritems[0]?.live_date_time > 1
                    }
                    navigateTo="/login"
                    fontSize={resolution === "FHD" ? "26px" : "18px"}
                    defaultSelected={isWatchNowSelected}
                    height={resolution === "FHD" ? "80px" : "53px"}
                    top="50vh"
                    onClick={(e) => {
                      handleClick(null, 1);
                    }}
                    className="carousel-image"
                    style={{
                      opacity: index === currentIndex ? 1 : 0,
                      transition: "opacity 1s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      {banneritems[0]?.live_date_time &&
                        banneritems[0]?.live_end_time > 1
                        ? ""
                        :
                        banneritems[0]?.live_date_time === 0 &&
                          banneritems[0]?.live_end_time === 0
                          ? ""
                          :null}
                    </div>
                    <div
                    >

                      <img
                        src={playIcon}
                        style={{
                          width: resolution === "FHD" ? "26px" : "18px",
                          height: resolution === "FHD" ? "31px" : "22px",
                          position: "relative",
                          right: resolution === "FHD" ? "8px" : "8px",
                          top: resolution === "FHD" ? "3px" : "3px",
                          display:
                            (banneritems[0]?.is_live === 0 &&
                              banneritems[0]?.live_date_time &&
                              !isTimeExpired(banneritems[0]?.live_date_time) || banneritems[0]?.still_live === 1)
                              ? "none"
                              : "inline",
                        }}
                        alt="Play Button"
                      />
                      <span
                        style={{
                          marginLeft: "3px",
                          position: "relative",
                          top: resolution === "FHD" ? "-3px" : "-4px",
                          // You can adjust the value as needed (e.g., "24px", "32px")
                        }}
                      >{console.log("tabcontent...", TabContent,itemDetails[0])}
                        {banneritems[0]?.paused_at >= 0 ? (
                          <>
                            <Translate langKey="ResuminWating" />{" "}
                            {(dataItem?.ep_No ||
                              dataItem?.ep_No) && (
                                <>
                             
                                  {dataItem?.s_No &&
                                    `S${dataItem.s_No}\u00A0`}
                                  {dataItem?.ep_No &&
                                    `E${dataItem.ep_No}`}
                                </>
                              )}
                          </>
                            
                        
                        ) : banneritems[0]?.type === 1 ||
                          banneritems[0]?.media_type === 1 ? (
                          <Translate langKey={"ListenToWatch"} />
                        ) : banneritems[0]?.type === 4 ||
                          banneritems[0]?.type === 7 ||
                          banneritems[0]?.type === 5 ||
                          banneritems[0]?.media_type === 7 ||
                          banneritems[0]?.media_type === 4 ||
                          banneritems[0]?.media_type === 5 ? (
                          "View Now"
                        ) : banneritems[0]?.is_live === 0 ? (
                          banneritems[0]?.live_date_time ? (
                            isTimeExpired(banneritems[0]?.live_date_time) ? (
                              `Watch since ${formatUnixToDate(
                                banneritems[0]?.live_date_time
                              )}`
                            ) : (
                              `Begins on ${formatUnixToDate(
                                banneritems[0]?.live_date_time
                              )}`
                            )
                          ) : (
                            <Translate langKey={"Watchnow"} />
                          )
                        ) : banneritems[0]?.is_live === 4 ? (
                          <Translate langKey={"Begins_on"} />
                        ) : (
                          <Translate langKey={"Watchnow"} />
                        )}
                      </span>
                    </div>
                  </CustomButton>
                )}
                {console.log(banneritems[0].is_paid, "banneritems[0].is_paid")}
                {banneritems[0]?.paused_at >= 0 && (
                    <CustomButton
                      navigateTo="/login"
                      fontSize={resolution === "FHD" ? "26px" : "18px"}
                      defaultSelected={isStartOverSelected}
                      // width={resolution === "FHD" ? "80px" : "53px"}
                      height={resolution === "FHD" ? "80px" : "53px"}
                      top={resolution === "FHD" ? "50vh" : "45vh"}
                      onClick={(e) => {
                        handleClick(null, 10);
                      }}
                      className="carousel-image"
                      style={{
                        opacity: index === currentIndex ? 1 : 0,
                        transition: "opacity 1s",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "1rem",
                        fontWeight: "bold",
                      }}
                      margingcustom={itemDetails[0]?.is_paid === 2 ? true : false}
                    >
                      <img
                        src={
                          start_over
                        }
                        id={banneritems[0]?.id}
                        style={{
                          width: resolution === "FHD" ? "35px" : "22px",
                          height: resolution === "FHD" ? "35px" : "22px",
                          // marginLeft: resolution === "FHD" ? "0px" : "-5px",
                          marginTop: resolution === "FHD" ? "5px" : "2px",
                        }}
                        alt="Start Over"
                      />
                    </CustomButton>
                  )}
              </div>

              {console.log(itemDetails[0], "itemDetails")}

              {banneritems[0]?.live_date_time || isLiveEvent ? null : (
                <>
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      gap: "1rem",
                    }}
                  >
                    {isBelliconSelected && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "-7rem",
                          background: "transparent",
                          padding: "6px 12px",
                          color: "#fff",
                          borderRadius: "8px",
                          fontSize: resolution === "FHD" ? "20px" : "14px",
                          fontWeight: "bold",
                        }}
                      >
                        Remind Me
                      </div>
                    )}
                    {/* ===== New Header for Watchlist Button ===== */}
                    {(isStartOverSelected && banneritems[0].is_paid !== 3 && banneritems[0].is_paid !== 2) && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "-7rem",
                          background: "transparent",
                          padding: "6px 12px",
                          color: "#fff",
                          borderRadius: "8px",
                          fontSize: resolution === "FHD" ? "20px" : "14px",
                          fontWeight: "bold",
                        }}
                      >
                        <marquee
                          behavior="scroll"
                          direction="left"
                          scrollAmount="4"
                        // style={{ width: "414px" }}
                        >
                          <Translate langKey={"startOver"} />
                        </marquee>
                      </div>
                    )}

                    {/* ===== New Header for Watchlist Button ===== */}
                    {isAddFavoriteSelected && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "-0.2rem",
                          background: "transparent",
                          padding: "6px 12px",
                          color: "#fff",
                          borderRadius: "8px",
                          fontSize: resolution === "FHD" ? "20px" : "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {/* Watchlist */}
                        <Translate langKey={"Watchlist"} />
                      </div>
                    )}

                    {/* ===== New Header for Like Button ===== */}
                    {isLikeSelected && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "8rem", // Adjust left as needed for positioning
                          background: "transparent",
                          color: "#fff",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: resolution === "FHD" ? "20px" : "14px",
                          fontWeight: "bold",
                        }}
                      >
                        <Translate langKey={"like"} />
                      </div>
                    )}

                    {/* ===== New Header for Dislike Button ===== */}
                    {isDislikeSelected && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "14.2rem", // Adjust left as needed for positioning
                          background: "transparent",
                          color: "#fff",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: resolution === "FHD" ? "20px" : "14px",
                          fontWeight: "bold",
                        }}
                      >
                        <Translate langKey={"dislike"} />
                      </div>
                    )}

                    {!isLiveScreen ? (
                      <CustomButton
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        defaultSelected={isAddFavoriteSelected}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top={resolution === "FHD" ? "50vh" : "45vh"}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "1rem",
                        }}
                        onClick={(e) => {
                          handleClick(null, 2);
                        }}
                        margingcustom={
                          itemDetails[0]?.is_paid === 2 ? true : false
                        }
                      >
                        <img
                          src={
                            watchlistItems?.find(
                              (data) =>
                                data.show_id === item.id &&
                                data.is_deleted !== 1
                            )
                              ? favouriteIcon
                              : addtofavouriteIcon
                          }
                          id={itemDetails}
                          style={{
                            width: resolution === "FHD" ? "35px" : "22px",
                            height: resolution === "FHD" ? "35px" : "22px",
                            marginLeft: resolution === "FHD" ? "0px" : "-5px",
                            marginTop: resolution === "FHD" ? "5px" : "2px",
                          }}
                          alt="Add to Favorite"
                        />
                      </CustomButton>
                    ) : null}
                    {!isLiveScreen ? (
                      <CustomButton
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        defaultSelected={isLikeSelected}
                        // width={resolution === "FHD" ? "80px" : "53px"}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top={resolution === "FHD" ? "50vh" : "45vh"}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "1rem",
                        }}
                        onClick={(e) => {
                          handleClick(null, 3);
                        }}
                        margingcustom={
                          itemDetails[0]?.is_paid === 2 ? true : false
                        }
                      >
                        <img
                          src={
                            likeDislikeItems.find(
                              (data) =>
                                data.show_id === item.id &&
                                data.rating === "like"
                            )
                              ? selectedlikeIcon
                              : likeIcon
                          }
                          style={{
                            width: resolution === "FHD" ? "35px" : "22px",
                            height: resolution === "FHD" ? "35px" : "22px",
                            marginLeft: resolution === "FHD" ? "0px" : "-5px",
                            marginTop: resolution === "FHD" ? "5px" : "2px",
                          }}
                          alt="More Info Button"
                        />
                      </CustomButton>
                    ) : null}
                    {!isLiveScreen ? (
                      <CustomButton
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        defaultSelected={isDislikeSelected}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top={resolution === "FHD" ? "50vh" : "45vh"}
                        onClick={(e) => {
                          handleClick(null, 4);
                        }}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                        }}
                        margingcustom={
                          itemDetails[0]?.is_paid === 2 ? true : false
                        }
                      >
                        <img
                          src={
                            likeDislikeItems.find(
                              (data) =>
                                data.show_id === item.id &&
                                data.rating === "dislike"
                            )
                              ? selectedDislikeIcon
                              : dislikeIcon
                          }
                          style={{
                            width: resolution === "FHD" ? "35px" : "22px",
                            height: resolution === "FHD" ? "35px" : "22px",
                            marginLeft: resolution === "FHD" ? "0px" : "-5px",
                            marginTop: resolution === "FHD" ? "5px" : "2px",
                          }}
                          alt="More Info Button"
                        />
                      </CustomButton>
                    ) : null}
                  </div>
                  <div style={{ position: "absolute", left: "-2rem" }}>
                    {!shoulddetailsOpen && (
                      <>

                        {isSeries && !isLiveEvent && Episodes.length > 0 && (
                          <Wrapper
                            style={{
                              position: "absolute",
                              display: "flex",
                              // marginLeft: "118px",
                              marginTop: "41rem",
                              width: "211px",
                              height: "59px",
                              background: "transparent",
                              borderRadius: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(40, 5);
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "49px",
                                width: "211px",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.7rem",
                                background: "transparent",
                                // marginLeft: "0px",
                                right: "1rem",
                                marginTop: "0px",
                                color: "#FFFFFF",
                              }}
                            >
                              {itemDetails[0]?.type === 1 ? (
                                   <Translate langKey={ "Tracks"} />
                              ) : (
                                <Translate langKey={"episodes"} />
                              )}
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "5px",
                                width: "105px",
                                background: isEpisodeSelected
                                  ? "#EC008C"
                                  : "transparent",
                                marginLeft: "40px",
                                marginTop: "54px",
                                borderRadius: "10px",
                              }}
                            ></div>
                          </Wrapper>
                        )}{console.log("artist4972...", artist, artist.length)}
                        {artist && artist.length > 0 && (
                          <Wrapper
                            style={{
                              position: "absolute",
                              display: "flex",
                              marginLeft:
                                Episodes?.length > 0 &&
                                  Episodes[0]?.episodes?.length > 0
                                  ? // ? "348px"
                                  "180px"
                                  // : "188px",
                                  : "0px",
                              marginTop: "41rem",
                              width: "211px",
                              height: "59px",
                              background: "transparent",
                              borderRadius: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(40, 5);
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "49px",
                                width: "211px",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.7rem",
                                background: "transparent",
                                marginLeft: "0px",
                                marginTop: "0px",
                                color: "#FFFFFF",
                              }}
                            >
                              <Translate langKey={"cast_crew"} />
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "5px",
                                width: "105px",
                                background: isCastCreSelected
                                  ? "#EC008C"
                                  : "transparent",
                                marginLeft: "52px",
                                marginTop: "54px",
                                borderRadius: "10px",
                              }}
                            ></div>
                          </Wrapper>
                        )}
                        {similar && similar.length > 0 && (
                          <Wrapper
                            style={{
                              position: "absolute",
                              display: "flex",
                              marginLeft:
                                similar && similar.length > 0 && artist && artist.length > 0 && !Episodes.length > 0
                                  ? // ? "630px"
                                    // "385px"
                                    "255px"
                                    :similar && similar.length > 0 && artist && artist.length > 0 && Episodes.length > 0 &&
                                    Episodes[0].episodes.length > 0
                                    ? "385px"
                                    : similar && similar.length > 0 && artist && artist.length > 0
                                      ? "255px"
                                  : Episodes.length > 0 &&
                                    Episodes[0].episodes.length > 0
                                    // ? "348px"
                                    ? "200px"
                                    : "0px",
                              marginTop: "41rem",
                              width: "211px",
                              height: "59px",
                              background: "transparent",
                              borderRadius: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(40, 5);
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "49px",
                                width: "211px",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.7rem",
                                background: "transparent",
                                marginLeft: Episodes[0]?.episodes?.length > 0 ? "0rem" : isLiveScreen ? "0" : isLiveEvent ? "0" : similar.length > 0 ? "0" : "9rem",
                                // marginLeft: "0px",
                                marginTop: "0px",
                                color: "#FFFFFF",
                              }}
                            >
                              {/* Similar To This */}

                              {itemDetails[0]?.still_live == 0 ? (
                                <Translate langKey={"similar_to_this"} />
                              ) : (
                                <Translate langKey={"similar_channels"} />
                              )}
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "5px",
                                width: "105px",
                                background: isSimilarSelected
                                  ? "#EC008C"
                                  : "transparent",
                                marginLeft: "52px",
                                marginTop: "54px",
                                borderRadius: "10px",
                              }}
                            ></div>
                          </Wrapper>
                        )}
                        <div
                          style={{
                            position: "absolute",
                            width: "95vw",
                            height: "260px",
                            background: "transparent",
                            marginTop: "46rem",
                            // marginLeft: "93px",
                          }}
                        >
                          {console.log("dddd", TabContent)}
                          {console.log("vab ", selectedItemId)}
                          <MarkupGrid
                          shouldRental={shouldRental}
                            items={TabContent}
                            forceThumbnailType={selectedItemId}
                            onItemSelected={handleItemSelected}
                            rowWidth="100%"
                            rowHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 249
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 270 : 230)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 315 : 300)
                                    : 395
                            }
                            columnWidth={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 394 : 152)
                                : selectedItemId === "similaritems"
                                  ? (resolution === "FHD" ? 228 : 180)
                                  : (resolution === "FHD" ? 394 : 152)
                            }
                            columnHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 221 : 194)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 260 : 220)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 281 : 270)
                                    : (resolution === "FHD" ? 221 : 194)
                            }
                            itemWidth={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 404 : 152)
                                : selectedItemId === "similaritems"
                                  ? (resolution === "FHD" ? 285 : 190)
                                  : (resolution === "FHD" ? 404 : 152)
                            }
                            itemHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 232 : 194)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 150 : 150)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 422 : 280)
                                    : (resolution === "FHD" ? 232 : 194)
                            }
                            numberOfDefaultRows={2}
                            selectionColor={
                              shouldFocusGrid ? "#EC008C" : "transparent"
                            }
                            numberOfColumnsEachRow={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 4
                                : selectedItemId === "similaritems"
                                  ? 8
                                  : selectedItemId === "castcrew"
                                    ? 9
                                    : 4
                            }
                            selectionStyle="border"
                            gapBetweenColumns={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 35
                                : selectedItemId === "similaritems"
                                  ? 10
                                  : selectedItemId === "castcrew"
                                    ? 20
                                    : 35
                            }
                            gapBetweenRows={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 5 : 7)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 15 : 5)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 0 : 10)
                                    : (resolution === "FHD" ? 10 : 7)
                            }
                            columnBgColorOrImage="#000000"
                            rowBgColorOrImage="transparent"
                            shouldScrollHorizontally={false}
                            shouldScrollVertically={true}
                            scrollDuration={300}
                            GridXCordinate={0}
                            GridYCordinate={0}
                            shouldFocus={shouldFocusGrid}
                            callBack={callBack}
                            navigate={navigateToScreen}
                            itemComponentName={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 'EpisodesWidget'
                                : selectedItemId === "similaritems"
                                  ? "SimilarToThis"
                                  : itemComponentName
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )
      )
    );

  const startTime =
    itemDetails[0]?.endtime !== undefined
      ? parseInt(itemDetails[0]?.endtime) * 1000
      : parseInt(banneritems[0]?.endtime) * 1000;
  // const now = Date.now();
  // const hoursRemaining = (startTime - now) / (1000 * 60 * 60);
  // const launchesIn24Hours = startTime > 0 && startTime < window.CWPOOLING;

const now = Date.now();
const hoursRemaining = (startTime - now) / (1000 * 60 * 60);
const launchesIn24Hours = startTime > 0 && startTime < window.CWPOOLING;

const dateObj = new Date(startTime);

// VIDAA month handling
const day = String(dateObj.getDate()).padStart(2, "0");

const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const month = months[dateObj.getMonth()];
const date = `${day} ${month}`;

// ✅ Time formatting
let hours = dateObj.getHours();
const ampm = hours >= 12 ? "PM" : "AM";
hours = hours % 12 || 12;

const time = `${hours} ${ampm}`;

// ✅ Final output
const upcomingLaunches = `${date} ${time}`;

  const teaser_countdown =
    Math.ceil(hoursRemaining) <= window.TEASER_COUNTDOWN / 3600;

  const launchesComingSoon =
    launchesIn24Hours && teaser_countdown ? (
      `Launches in ${Math.ceil(hoursRemaining)} hours`
    ) : (
      <>
        <Translate langKey={"streaming_from"} /> {upcomingLaunches}{" "}
      </>
    );

  const renderContent1 = (items) =>
    items.map(
      (item, index) => (
        (
          <div key={item.id}>
            {isLiveScreen ? (
              <img
                id={item.id ? item.id : 0}
                src={item.poster_url ? item.poster_url : item.detail_banner}
                alt={item.title ? item.title : ""}
                className="carousel-image"
                style={{
                  ...styles.image,
                  opacity: index === currentIndex ? 1 : 0,
                  transition: "opacity 1s", // Smooth fade transition
                }}
              />
            ) : (
              (item.banner_url || item.detail_banner) && (
                <>
                  {item.isTeaser === 1 &&
                    item.season?.[0]?.videos?.[0]?.is_trailer === 0 ? (
                    <div
                      style={{
                        position: "absolute",
                        width: "100vw",
                        // height: "100vh",
                        background: "transparent",
                        overflow: "hidden",
                        margin: "0px",
                      }}
                    >
                      <HomeBGVideoPlayer
                        videoSrc={videoURL}
                        type="m3u8"
                        fullScreen={true}
                        shouldShowBGVideo={true}
                      />
                    </div>
                  ) : (
                    // ✅ Otherwise show image if available
                    (item.banner_url || item.detail_banner) && (
                      <img
                        id={item.id ? item.id : 0}
                        src={
                          item.banner_url ? item.banner_url : item.detail_banner
                        }
                        alt={item.title ? item.title : ""}
                        className="carousel-image"
                        style={{
                          ...styles.image,
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                        }}
                      />
                    )
                  )}
                </>
              )
            )}

            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            >
              <img
                src={ShadowLayer}
                alt="Shadow Layer"
                style={styles.shadowLayer}
              />
            </div>
            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
                fontWeight: "bold",
                fontSize: resolution === "FHD" ? "40px" : "27px",
                color: "#F1F1F1",
                position: "absolute",
                width: "100%",
                height: resolution === "FHD" ? "138px" : "92px",
                marginTop: "10rem",
                marginLeft: "7.1rem",
                background: "transparent",
                display: "flex",
                alignItems: "end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "-3rem",
                  marginLeft: "0.2rem",
                  gap: "0.2rem",
                }}
              >
                {item.banner_icon ? (
                  <img
                    src={item.banner_icon}
                    height={resolution === "FHD" ? "138px" : "92px"}
                    alt="Placeholder"
                    style={{
                      objectFit: "contain",
                      objectPosition: "left",
                      borderRadius: "0.5rem",
                      height: "12rem",
                      width: "auto",
                      marginBottom: "1rem",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      color: "rgb(173, 183, 240)",
                      fontWeight: "bold",
                      fontSize: "3rem",
                      lineHeight: "1",
                      textTransform: "uppercase",
                    }}
                  >
                    {console.log(
                      item,
                      banneritems,
                      itemDetails[0]?.partner_image_detail_page,
                      itemDetails[0]?.publisher_logo,
                      "CheckTItle"
                    )}
                    {itemDetails[0]?.partner_image_detail_page != null ? (
                      <img
                        style={{ width: "20%" }}
                        src={itemDetails[0]?.partner_image_detail_page}
                      />
                    ) : (
                      <img
                        style={{ width: "20%" }}
                        src={itemDetails[0]?.publisher_logo}
                      />
                    )}
                    {item?.title}
                  </div>
                )}

                <div
                  style={{
                    fontSize: "24px",
                    color: "rgb(137, 150, 185)",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                  }}
                >
                  {item?.skip_season == 0 && (
                    <>
                      {item?.season_count}{" "}
                      {item?.season_count > 1 ? "Seasons" : "Season"} {" . "}
                    </>
                  )}
                  {item.video_time !== 0 && item.skip_season == 1 && (
                    <>
                      {formatTime(item.video_time)}
                      {(item.language_title ||
                        item.agency ||
                        item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        " . "}
                    </>
                  )}
                  {item?.language_title && (
                    <>
                      {item.language_title}
                      {(item.agency ||
                        item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        " . "}
                    </>
                  )}
                  {item.agency && (
                    <>
                      {item.agency}
                      {(item.certificate ||
                        (item.rating_json && item.rating_json[0]?.rating)) &&
                        " . "}
                    </>
                  )}
                  {item.certificate && (
                    <>
                      {item.certificate}
                      {item.rating_json && item.rating_json[0]?.rating && " . "}
                    </>
                  )}
                  
                  {item.rating_json && item.rating_json[0]?.rating && (
                    <span style={{ position: "relative", top: "10px" }}>
                      <img src={idmdimg} alt="Rating" />
                      <span style={{ position: "relative", top: "-8px" }}>
                        &nbsp;{item.rating_json[0].rating}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div
              className="carousel-image"
              style={{
                opacity: 1,
                transition: "opacity 1s",
                color: "rgb(201, 206, 221)",
                fontSize: resolution === "FHD" ? "30px" : "20px",
                position: "absolute",
                width: readMore ? "80%" : "90vh",
                height: "15vh",
                marginTop: "24rem",
                marginLeft: resolution === "FHD" ? "7.5rem" : "5rem", // Converted 118px to rem
                background: "transparent",
                overflow: "hidden",
                textOverflow: "ellipsis",
                zIndex: shoulddetailsOpen ? "0" : "1",
              }}
            >
              {item?.description &&
                item?.description.find((item) => item.language)
                ? item?.description.find(
                  (item) =>
                    item.language === localStorage.getItem("AppLanguage")
                )
                  ?
                    truncateText(
                      item.description.find(
                        (item) =>
                          item.language ===
                          localStorage.getItem("AppLanguage")
                      ).content
                    )
                  
                  : truncateText(item?.description[0]?.content)
                : ""}
              {item?.description[0]?.content !== "" &&
                item?.description[0]?.content.split(" ").length > 5 &&
                banneritems[currentIndex]?.playlist_type !== "upcoming" &&
                item?.description[0]?.content.length > 200 ? (
                <span
                  style={{
                    color: focusedIndex === 9 ? "#EC008C" : "#fff",

                    cursor: "pointer",
                    // textDecoration: focusedIndex === 9 ? "underline #fff" : "",
                  }}
                  onClick={(e) => {
                    // BGScreenKeyHandler(9, null);
                    if (item?.description[0]?.content.length > 200)
                      setReadMore((prev) => !prev);
                  }}
                >
                  {!readMore ? (
                    <Translate langKey={"view_more"} />
                  ) : (
                    <Translate langKey={"view_less"} />
                  )}
                </span>
              ) : (
                ""
              )}
            </div>
            <div
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
                position: "absolute",
                width: "35vw",
                height: "6vh",
                marginTop: "38rem",
                marginLeft: "4vw",
                marginLeft: "2.5vw",
                background: "transparent",
              }}
            >
              {item?.genres !== undefined && item?.genres !== null
                ? (() => {
                  const genres = item?.genres?.split(",")?.slice(0, 3); // Split genres and take the first three
                  const [item1, item2, item3] = genres; // Destructure into individual items

                  return (
                    <>
                      {item1 && item2 && item3 && (
                        <p
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "4.5rem",
                            marginTop: "-8rem",
                            position: "absolute",
                            height: "2vh",
                            borderRadius: "0px",
                            background: "transparent",
                            color: "rgb(137, 150, 185)",
                            display: "inline-flex",
                            fontSize:
                              resolution === "FHD" ? "1.4rem" : "1.2rem",
                          }}
                        >
                          {item1} | {item2} | {item3}
                        </p>
                      )}
                    </>
                  );
                })()
                : null}
            </div>

            {itemDetails[0]?.endtime !== "" &&
              itemDetails[0]?.endtime !== null &&
              itemDetails[0]?.endtime !== undefined &&
              startTime > now && (
                <div
                  style={{
                    display: isDetails ? "flex" : "none",
                    position: "absolute",
                    left: "7rem",
                    gap: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      gap: "1rem",
                    }}
                  >
                    {itemDetails[0]?.is_paid === 1 && !subscriptionCheck ? (
                      <CustomButton
                        isLiveText={
                          banneritems[0]?.is_live === 0 &&
                          banneritems[0]?.live_date_time > 1
                        }
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        defaultSelected={isWatchNowSelected}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top="50vh"
                        onClick={(e) => {
                          handleClick(null, 1);
                        }}
                        className="carousel-image"
                        display="flex"
                        alignItems="center"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.2rem",
                          fontWeight: "bold",
                        }}
                        IsSubscribe={true}
                      >
                        <img
                          src={playIcon}
                          style={{
                            width: resolution === "FHD" ? "26px" : "18px",
                            height: resolution === "FHD" ? "31px" : "22px",
                            marginRight: "14px",
                          }}
                          alt="Play Button"
                        />
                        {/* <p>Subscribe to watch</p> */}
                        <p><Translate langKey={"Subscribe to watch"} /></p>
                      </CustomButton>
                    ) : itemDetails[0]?.is_paid === 2 ||
                      itemDetails[0]?.is_paid === 3 ? (
                      // ) : window.IS_ON_RENT !== 1 ? (
                      <CustomButton
                        isLiveText={
                          banneritems[0]?.is_live === 0 &&
                          banneritems[0]?.live_date_time > 1
                        }
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        defaultSelected={isWatchNowSelected}
                        // width={resolution === "FHD" ? "254px" : "169px"}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top="50vh"
                        // left={resolution === "FHD" ? "118px" : "80px"}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.8rem",
                          fontWeight: "bold",
                          fontSize: "22px",
                        }}
                        onClick={(e) => {
                          handleClick(null, 1);
                        }}
                        widthSubscribe={true}
                      >
                        {window.IS_ON_RENT !== 1 ? (
                          "")
                          : (<img
                            src={playIcon}
                            style={{
                              width: resolution === "FHD" ? "26px" : "18px",
                              height: resolution === "FHD" ? "31px" : "22px",
                              marginRight: "14px",
                            }}
                            alt="Play Button"
                          />)}
                        {window.IS_ON_RENT !== 1 ? (
                          <>
                            <Translate langKey={"availableOnRent"} /> ₹
                            {itemDetails[0]?.pricing?.s_price +
                              itemDetails[0]?.pricing?.gst_amount}
                          </>
                        ) : (
                          <Translate langKey={"watchNow"} />
                        )}
                      </CustomButton>
                    ) : itemDetails[0]?.type === 6 ? (
                      <CustomButton
                        isLiveText={
                          banneritems[0]?.is_live === 0 &&
                          banneritems[0]?.live_date_time > 1
                        }
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        top="50vh"
                        onClick={(e) => {
                          handleClick(null, 1);
                        }}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.8rem",
                          fontWeight: "bold",
                        }}
                      >
                        <div>
                          {banneritems[0]?.live_date_time &&
                            banneritems[0]?.live_end_time > 1 ? (
                            <img
                              src={playIcon}
                              style={{
                                width: resolution === "FHD" ? "26px" : "18px",
                                height: resolution === "FHD" ? "31px" : "22px",
                              }}
                              alt="Play Button"
                            />
                          ) : banneritems[0]?.live_date_time === 0 &&
                            banneritems[0]?.live_end_time === 0 ? (
                            <img
                              src={playIcon}
                              style={{
                                width: resolution === "FHD" ? "26px" : "18px",
                                height: resolution === "FHD" ? "31px" : "22px",
                                display:
                                  banneritems[0]?.is_live === 0 &&
                                    banneritems[0]?.live_date_time &&
                                    !isTimeExpired(banneritems[0]?.live_date_time)
                                    ? "none"
                                    : "inline",
                              }}
                              alt="Play Button"
                            />
                          ) : null}
                        </div>
                        <div>
                          {banneritems[0]?.type == 1 ? (
                            <Translate langKey={"ListenToWatch"} />
                          ) : banneritems[0]?.is_live === 0 ? (
                            banneritems[0]?.live_date_time ? (
                              isTimeExpired(banneritems[0]?.live_date_time) ? (
                                // "Watch since"
                                `Watch since ${formatUnixToDate(
                                  banneritems[0]?.live_date_time
                                )}`
                              ) : (
                                `Begins on ${formatUnixToDate(
                                  banneritems[0]?.live_date_time
                                )}`
                              )
                            ) : (
                              <Translate langKey={"HowToPlay"} />
                            )
                          ) : (
                            <Translate langKey={"HowToPlay"} />
                          )}
                        </div>
                      </CustomButton>
                    ) : (
                      <CustomButton
                        isLiveText={
                          banneritems[0]?.is_live === 0 &&
                          banneritems[0]?.live_date_time > 1
                        }
                        navigateTo="/login"
                        fontSize={resolution === "FHD" ? "26px" : "18px"}
                        // defaultSelected={isWatchNowSelected}
                        isCommingText={isWatchNowSelected}
                        // width={resolution === "FHD" ? "450px" : "350px"}
                        height={resolution === "FHD" ? "80px" : "53px"}
                        // left={resolution === "FHD" ? "118px" : "80px"}
                        top="50vh"
                        onClick={(e) => {
                          handleClick(null, 1);
                        }}
                        className="carousel-image"
                        style={{
                          opacity: index === currentIndex ? 1 : 0,
                          transition: "opacity 1s",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.8rem",
                          fontWeight: "bold",
                        }}
                      >
                        <div>
                          {banneritems[0]?.live_date_time &&
                            banneritems[0]?.live_end_time > 1 ? (
                            <img
                              src={
                                banneritems[0]?.type === 4 ||
                                  banneritems[0]?.type === 5 ||
                                  banneritems[0]?.type === 7 ||
                                  banneritems[0]?.media_type === 4 ||
                                  banneritems[0]?.media_type === 5 ||
                                  banneritems[0]?.media_type === 7
                                  ? eyeIcon
                                  : playIcon
                              }
                              style={{
                                width: resolution === "FHD" ? "26px" : "18px",
                                height: resolution === "FHD" ? "31px" : "22px",
                              }}
                              alt="Play Button"
                            />
                          ) : banneritems[0]?.live_date_time === 0 &&
                            banneritems[0]?.live_end_time === 0 ? (
                            <img
                              src={
                                banneritems[0]?.type === 4 ||
                                  banneritems[0]?.type === 5 ||
                                  banneritems[0]?.type === 7 ||
                                  banneritems[0]?.media_type === 4 ||
                                  banneritems[0]?.media_type === 5 ||
                                  banneritems[0]?.media_type === 7
                                  ? eyeIcon
                                  : playIcon
                              }
                              style={{
                                width: resolution === "FHD" ? "26px" : "18px",
                                height: resolution === "FHD" ? "31px" : "22px",
                                display:
                                  banneritems[0]?.is_live === 0 &&
                                    banneritems[0]?.live_date_time &&
                                    !isTimeExpired(banneritems[0]?.live_date_time)
                                    ? "none"
                                    : "inline",
                              }}
                              alt="Play Button"
                            />
                          ) : null}
                        </div>
                        <div>
                          {console.log(
                            "2333...4444.",
                            banneritems[0]?.paused_at,
                            banneritems
                          )}
                          {banneritems[0]?.paused_at >= 0 ? (
                            <Translate langKey={"ResuminWating"} />
                          ) : banneritems[0]?.type == 1 ||
                            banneritems[0]?.media_type == 1 ? (
                            <Translate langKey={"ListenToWatch"} />
                          ) : banneritems[0]?.type == 4 ||
                            banneritems[0]?.type == 7 ||
                            banneritems[0]?.type == 5 ||
                            banneritems[0]?.media_type == 7 ||
                            banneritems[0]?.media_type == 4 ||
                            banneritems[0]?.media_type == 5 ? (
                            "View Now"
                          ) : // <Translate langKey={"ListenToWatch"} />
                            banneritems[0]?.is_live === 0 ? (
                              banneritems[0]?.live_date_time ? (
                                isTimeExpired(banneritems[0]?.live_date_time) ? (
                                  // "Watch since"
                                  `Watch since ${formatUnixToDate(
                                    banneritems[0]?.live_date_time
                                  )}`
                                ) : (
                                  `Begins on ${formatUnixToDate(
                                    banneritems[0]?.live_date_time
                                  )}`
                                )
                              ) : (
                                <span>{launchesComingSoon}</span>
                                // <Translate langKey={"Watchnow"} />
                              )
                            ) : (
                              <Translate langKey={"Watchnow"} />
                            )}
                        </div>
                      </CustomButton>
                    )}
                  </div>
                  {banneritems[0]?.live_date_time || isLiveEvent ? null : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          position: "relative",
                          gap: "1rem",
                        }}
                      >
                        {!isLiveScreen ? (
                          <CustomButton
                            navigateTo="/login"
                            fontSize={resolution === "FHD" ? "26px" : "18px"}
                            defaultSelected={isBelliconSelected}
                            // width={resolution === "FHD" ? "80px" : "53px"}
                            height={resolution === "FHD" ? "80px" : "53px"}
                            top={resolution === "FHD" ? "50vh" : "45vh"}
                            onClick={()=>{
                                  focusedIndex = 14;
                                  shouldFocusToScreenBG = false;
                                  setState((prevState) => ({
                                    ...prevState,
                                    isWatchNowSelected: true,
                                    isAddFavoriteSelected: false,
                                    isLikeSelected: false,
                                    isDislikeSelected: false,
                                    isBelliconSelected: false,
                                  }));
                                  window.removeEventListener("keydown", BGScreenKeyHandler);
                                  isKeyListenerAdded = false;
                                  handleErr("GET-REMINDER");
                                                      }}
                            className="carousel-image"
                            style={{
                              opacity: index === currentIndex ? 1 : 0,
                              transition: "opacity 1s",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "1rem",
                              fontWeight: "bold",
                            }}
                            margingcustom={
                              itemDetails[0]?.is_paid === 2 ? true : false
                            }
                          >
                            <img
                              src={
                                window.REMINDER_STATUS === 1
                                  ? bell_icon_selected
                                  : bell_icon_unselected
                              }
                              id={itemDetails}
                              style={{
                                width: resolution === "FHD" ? "35px" : "22px",
                                height: resolution === "FHD" ? "35px" : "22px",
                                marginLeft:
                                  resolution === "FHD" ? "0px" : "-5px",
                                marginTop: resolution === "FHD" ? "5px" : "2px",
                              }}
                              alt="Add to Favorite"
                            />
                          </CustomButton>
                        ) : null}

                        {!isLiveScreen ? (
                          <CustomButton
                            navigateTo="/login"
                            fontSize={resolution === "FHD" ? "26px" : "18px"}
                            defaultSelected={isLikeSelected}
                            // width={resolution === "FHD" ? "80px" : "53px"}
                            height={resolution === "FHD" ? "80px" : "53px"}
                            top={resolution === "FHD" ? "50vh" : "45vh"}
                            className="carousel-image"
                            style={{
                              opacity: index === currentIndex ? 1 : 0,
                              transition: "opacity 1s",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(null, 3);
                            }}
                            margingcustom={
                              itemDetails[0]?.is_paid === 2 ? true : false
                            }
                          >
                            <img
                              src={
                                likeDislikeItems.find(
                                  (data) =>
                                    data.show_id === item.id &&
                                    data.rating === "like"
                                )
                                  ? selectedlikeIcon
                                  : likeIcon
                              }
                              style={{
                                width: resolution === "FHD" ? "35px" : "22px",
                                height: resolution === "FHD" ? "35px" : "22px",
                                marginLeft:
                                  resolution === "FHD" ? "0px" : "-5px",
                                marginTop: resolution === "FHD" ? "5px" : "2px",
                              }}
                              alt="More Info Button"
                            />
                          </CustomButton>
                        ) : null}
                        {!isLiveScreen ? (
                          <CustomButton
                            navigateTo="/login"
                            fontSize={resolution === "FHD" ? "26px" : "18px"}
                            defaultSelected={isDislikeSelected}
                            // width={resolution === "FHD" ? "80px" : "53px"}
                            height={resolution === "FHD" ? "80px" : "53px"}
                            top={resolution === "FHD" ? "50vh" : "45vh"}
                            onClick={(e) => {
                              handleClick(null, 4);
                            }}
                            className="carousel-image"
                            style={{
                              opacity: index === currentIndex ? 1 : 0,
                              transition: "opacity 1s",
                            }}
                            margingcustom={
                              itemDetails[0]?.is_paid === 2 ? true : false
                            }
                          >
                            <img
                              src={
                                likeDislikeItems.find(
                                  (data) =>
                                    data.show_id === item.id &&
                                    data.rating === "dislike"
                                )
                                  ? selectedDislikeIcon
                                  : dislikeIcon
                              }
                              style={{
                                width: resolution === "FHD" ? "35px" : "22px",
                                height: resolution === "FHD" ? "35px" : "22px",
                                marginLeft:
                                  resolution === "FHD" ? "0px" : "-5px",
                                marginTop: resolution === "FHD" ? "5px" : "2px",
                              }}
                              alt="More Info Button"
                            />
                          </CustomButton>
                        ) : null}
                      </div>
                      {isSeries && !isLiveEvent && Episodes.length > 0 && (
                        <Wrapper
                          style={{
                            position: "absolute",
                            display: "flex",
                            marginLeft: "118px",
                            marginTop: "40rem",
                            width: "211px",
                            height: "59px",
                            background: "transparent",
                            borderRadius: "1rem",
                          }}
                          onClick={(e) => {
                            handleClick(40, 5);
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              display: "flex",
                              height: "49px",
                              width: "211px",
                              textAlign: "center",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.7rem",
                              background: "transparent",
                              marginLeft: "0px",
                              marginTop: "0px",
                              color: "#FFFFFF",
                            }}
                          >
                            {itemDetails[0]?.type === 1 ? (
                                 <Translate langKey={ "Tracks"} />
                            ) : (
                              <Translate langKey={"episodes"} />
                            )}
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              display: "flex",
                              height: "5px",
                              width: "105px",
                              background: isEpisodeSelected
                                ? "#EC008C"
                                : "transparent",
                              marginLeft: "52px",
                              marginTop: "54px",
                              borderRadius: "10px",
                            }}
                          ></div>
                        </Wrapper>
                      )}
                       {artist && artist.length > 0 && (
                          <Wrapper
                            style={{
                              position: "absolute",
                              display: "flex",
                              marginLeft:
                                Episodes?.length > 0 &&
                                  Episodes[0]?.episodes?.length > 0
                                  ? // ? "348px"
                                  "180px"
                                  // : "188px",
                                  : "0px",
                              marginTop: "41rem",
                              width: "211px",
                              height: "59px",
                              background: "transparent",
                              borderRadius: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(40, 5);
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "49px",
                                width: "211px",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.7rem",
                                background: "transparent",
                                marginLeft: "0px",
                                marginTop: "0px",
                                color: "#FFFFFF",
                              }}
                            >
                              <Translate langKey={"cast_crew"} />
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "5px",
                                width: "105px",
                                background: isCastCreSelected
                                  ? "#EC008C"
                                  : "transparent",
                                marginLeft: "52px",
                                marginTop: "54px",
                                borderRadius: "10px",
                              }}
                            ></div>
                          </Wrapper>
                        )}
                        {similar && similar.length > 0 && (
                          <Wrapper
                            style={{
                              position: "absolute",
                              display: "flex",
                              marginLeft:
                                similar && similar.length > 0 && artist && artist.length > 0 && !Episodes.length > 0
                                  ? // ? "630px"
                                    // "385px"
                                    "255px"
                                    :similar && similar.length > 0 && artist && artist.length > 0 && Episodes.length > 0 &&
                                    Episodes[0].episodes.length > 0
                                    ? "385px"
                                    : similar && similar.length > 0 && artist && artist.length > 0
                                      ? "255px"
                                  : Episodes.length > 0 &&
                                    Episodes[0].episodes.length > 0
                                    // ? "348px"
                                    ? "200px"
                                    : "0px",
                              marginTop: "41rem",
                              width: "211px",
                              height: "59px",
                              background: "transparent",
                              borderRadius: "1rem",
                            }}
                            onClick={(e) => {
                              handleClick(40, 5);
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "49px",
                                width: "211px",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.7rem",
                                background: "transparent",
                                marginLeft: Episodes[0]?.episodes?.length > 0 ? "0rem" : isLiveScreen ? "0" : isLiveEvent ? "0" : similar.length > 0 ? "0" : "9rem",
                                // marginLeft: "0px",
                                marginTop: "0px",
                                color: "#FFFFFF",
                              }}
                            >
                              {/* Similar To This */}

                              {itemDetails[0]?.still_live == 0 ? (
                                <Translate langKey={"similar_to_this"} />
                              ) : (
                                <Translate langKey={"similar_channels"} />
                              )}
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                display: "flex",
                                height: "5px",
                                width: "105px",
                                background: isSimilarSelected
                                  ? "#EC008C"
                                  : "transparent",
                                marginLeft: "52px",
                                marginTop: "54px",
                                borderRadius: "10px",
                              }}
                            ></div>
                          </Wrapper>
                        )}
                      <div
                        style={{
                          position: "absolute",
                          width: "95vw",
                          height: "260px",
                          background: "transparent",
                          marginTop: "44.5rem",
                          marginLeft: "0px",
                          // marginLeft: "93px",
                        }}
                      >                        
                           <MarkupGrid
                          shouldRental={shouldRental}
                            items={TabContent}
                            forceThumbnailType={selectedItemId}
                            onItemSelected={handleItemSelected}
                            rowWidth="100%"
                            rowHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 249
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 270 : 230)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 315 : 300)
                                    : 395
                            }
                            columnWidth={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 394 : 152)
                                : selectedItemId === "similaritems"
                                  ? (resolution === "FHD" ? 228 : 180)
                                  : (resolution === "FHD" ? 394 : 152)
                            }
                            columnHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 221 : 194)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 260 : 220)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 281 : 270)
                                    : (resolution === "FHD" ? 221 : 194)
                            }
                            itemWidth={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 404 : 152)
                                : selectedItemId === "similaritems"
                                  ? (resolution === "FHD" ? 285 : 190)
                                  : (resolution === "FHD" ? 404 : 152)
                            }
                            itemHeight={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 232 : 194)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 150 : 150)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 422 : 280)
                                    : (resolution === "FHD" ? 232 : 194)
                            }
                            numberOfDefaultRows={2}
                            selectionColor={
                              shouldFocusGrid ? "#EC008C" : "transparent"
                            }
                            numberOfColumnsEachRow={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 4
                                : selectedItemId === "similaritems"
                                  ? 8
                                  : selectedItemId === "castcrew"
                                    ? 9
                                    : 4
                            }
                            selectionStyle="border"
                            gapBetweenColumns={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 35
                                : selectedItemId === "similaritems"
                                  ? 10
                                  : selectedItemId === "castcrew"
                                    ? 20
                                    : 35
                            }
                            gapBetweenRows={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? (resolution === "FHD" ? 5 : 7)
                                : selectedItemId === "castcrew"
                                  ? (resolution === "FHD" ? 15 : 5)
                                  : selectedItemId === "similaritems"
                                    ? (resolution === "FHD" ? 0 : 10)
                                    : (resolution === "FHD" ? 10 : 7)
                            }
                            columnBgColorOrImage="#000000"
                            rowBgColorOrImage="transparent"
                            shouldScrollHorizontally={false}
                            shouldScrollVertically={true}
                            scrollDuration={300}
                            GridXCordinate={0}
                            GridYCordinate={0}
                            shouldFocus={shouldFocusGrid}
                            callBack={callBack}
                            navigate={navigateToScreen}
                            itemComponentName={
                              (isLiveScreen && selectedItemId === 'similaritems')
                                ? 'EpisodesWidget'
                                : selectedItemId === "similaritems"
                                  ? "SimilarToThis"
                                  : itemComponentName
                            }
                          />
                      </div>
                    </>
                  )}
                </div>
              )}
          </div>
        )
      )
    );

  const RowlListcallBack = (SeletedItem, selectedIndx = -1) => {

    if (SeletedItem.id === "castcrew") {
      setState((prevState) => ({
        ...prevState,
        selectedItemId: "castcrew",
        TabContent: artist,
        shouldshowSeasonRowlist: false,
        episodeMarginTop: "165px",
      }));
    } else if (SeletedItem.id === "similaritems") {
      setState((prevState) => ({
        ...prevState,
        selectedItemId: "similaritems",
        TabContent: similar,
        shouldshowSeasonRowlist: false,
        episodeMarginTop: "165px",
      }));

    } else if (SeletedItem.id === "episodes") {
      setState((prevState) => ({
        ...prevState,
        selectedItemId: "episodes",
        TabContent: Episodes[0].episodes,
        shouldshowSeasonRowlist: true,
        episodeMarginTop: "265px",
      }));

      console.log("checkingInEpisdoes")

      // Send motamo Event
      sendEvent({ action: "EpisodeSelect",
         selectedItem: SeletedItem, 
         selectedIndex: selectedIndx,
         itemDetails:item 
        });

    } else if (selectedIndx >= 0) {

      // Send motamo Event
      sendEvent({ action: "ContentDetailPage",
         selectedItem: SeletedItem, 
         selectedIndex: selectedIndx,
         itemDetails:item 
        });

      setState((prevState) => ({
        ...prevState,
        TabContent:
          Episodes.length > 0 && Episodes[selectedIndx].episodes.length > 0
            ? Episodes[selectedIndx].episodes
            : artist.length > 0
              ? artist
              : similar.length > 0
                ? similar
                : [],
        shouldshowSeasonRowlist: true,
        episodeMarginTop: "265px",
      }));
    }
  };

  const handleBackButton = () => {
    console.log("handleBackButtoneee", focusedIndex, screen, screenName);

    let keyEvent = {
      isTrusted: true,
      code: "ArrowDown",
      key: "ArrowDown",
      keyCode: 8,
      type: "keydown",
    };

    BGScreenKeyHandler(keyEvent);
  };

  const handleRowListDownButton = () => {
    if ((shoulddetailsOpen || flg) && shouldFocusToRowList) {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToRowList: false,
        shouldFocusToSeasonRowList: shouldshowSeasonRowlist ? true : false,
        shouldFocusToEpisodeGrid: shouldshowSeasonRowlist ? false : true,
      }));
    } else if (
      (shoulddetailsOpen || flg) &&
      shouldFocusToSeasonRowList &&
      shouldshowSeasonRowlist
    ) {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToSeasonRowList: false,
        shouldFocusToEpisodeGrid: true,
      }));
    } else if (
      (shoulddetailsOpen || flg) &&
      !shouldFocusToRowList &&
      !shouldshowSeasonRowlist
    ) {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToRowList: false,
        shouldFocusToEpisodeGrid: true,
      }));
    }
  };

  const handleRowListUpButton = () => {
    console.log("handleRowListUpButtoncalled");
    if ((shoulddetailsOpen || flg) && shouldFocusToSeasonRowList) {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToRowList: true,
        shouldFocusToSeasonRowList: false,
      }));
    }
  };

  const handleMarkipGridUpButton = () => {
    if (shoulddetailsOpen || flg) {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToRowList: shouldshowSeasonRowlist ? false : true,
        shouldFocusToSeasonRowList: shouldshowSeasonRowlist ? true : false,
        shouldFocusToEpisodeGrid: false,
      }));
    }
  };

  const handleItemSelected = (item) => {
    focusedIndex = 1;
    window.removeEventListener("keydown", BGScreenKeyHandler);
    isKeyListenerAdded = false;
    flg = false;
    console.log("item selected in markup grid: ", itemDetails[0],item);
    
    setState((prevState) => ({
      ...prevState,
      shoulddetailsOpen: flg,
    }));
    

    onSelect(item);

    // Only fire SimilarToThis analytics when the user is viewing the "Similar To This" tab
    if (selectedItemId === "similaritems") {
      setSourceContext("SimilarToThis");
      sendSimilarThisEvent({ item: item, itemDetails: itemDetails[0] });
    }
    else if (selectedItemId === "episodes") {
      sendEvent({
        action: "EpisodeSelect",
        selectedItem: item,
        selectedIndex: null,
        itemDetails: itemDetails[0],
      });
    }

  };

  return (
    <div style={styles.ScreenBGItemContainer}>
      <div
        style={{
          position: "absolute",
          top: "1.6rem",
          zIndex: 100,
        }}
      >
        {!shoulddetailsOpen ? (
          <Wrapper
            as="button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "1rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
            }}
            onClick={(e) => {
              handleBack();
            }}
          >
            <img src={backIcon} width={50} height={50} />
          </Wrapper>
        ) : (
          ""
        )}
      </div>
      {(itemDetails[0]?.isTeaser === 0 || banneritems[0]?.isTeaser === 0) &&
        (!shoulddetailsOpen && itemDetails && itemDetails.length > 0
          ? renderContent(itemDetails)
          : renderContent(banneritems))}
      {(itemDetails[0]?.isTeaser === 1 || banneritems[0]?.isTeaser === 1) &&
        (!shoulddetailsOpen && itemDetails && itemDetails.length > 0
          ? renderContent1(itemDetails)
          : renderContent1(banneritems))}
      {shoulddetailsOpen &&
        (console.log("shoulddetailsOpen", shoulddetailsOpen, itemDetails),
          (
            <div
              style={{
                position: "absolute",
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                background: "#0E1653",
                marginTop: "0px",
                marginLeft: "0px",
              }}
            >
              <div
                id="your-rowlist-id"
                style={{
                  position: "absolute",
                  width: "100vw",
                  height: "10vh",
                  background: "#0E1653",
                  display: "flex", // <-- Add this
                  justifyContent: "flex-start", // <-- Add this to align items to the left
                }}
              >
                <RowList
                  rowWidth="auto" // <-- Change this to 'auto'
                  rowHeight="70px"
                  borderRadius="7.5px"
                  columnWidth="275px"
                  columnHeight="70px"
                  itemWidth="275px"
                  itemHeight="70px"
                  animationSpeed={300}
                  bgColor="transparent"
                  shouldFocus={shouldFocusToRowList}
                  marginLeft="78px" // This now acts as left padding for the entire row
                  marginTop="20px"
                  borderColor={shouldFocusToRowList ? "#EC008C" : "transparent"}
                  fontSize="26px"
                  fontColor="#FFFFFF"
                  selectionStyle="background"
                  gapBetweenColumn={15}
                  data={bottomShelfTabTitle}
                  RowlListcallBack={RowlListcallBack}
                  handleBackButton={handleBackButton}
                  handleRowListDownButton={handleRowListDownButton}
                  activeStyle={"underline"}
                  screen="ScreenBG"
                />
              </div>
              <div
                style={{
                  position: "absolute",
                  width: "95vw",
                  height: "1px",
                  background: "#cccccc",
                  marginTop: "120px",
                  marginLeft: "88px",
                }}
              ></div>
              {isSeries && shouldshowSeasonRowlist ? (
                <div
                  id="your-rowlist-id"
                  style={{
                    position: "absolute",
                    width: "100vw",
                    height: "10vh",
                    background: "#0E1653",
                    marginTop: "140px",
                  }}
                >
                  <RowList
                    rowWidth="1802px"
                    rowHeight="70px"
                    columnWidth="245px"
                    columnHeight="70px"
                    itemWidth="245px"
                    itemHeight="70px"
                    animationSpeed={100}
                    bgColor="transparent"
                    shouldFocus={shouldFocusToSeasonRowList}
                    marginLeft="78px"
                    marginTop="20px"
                    borderColor={
                      shouldFocusToSeasonRowList ? "#EC008C" : "transparent"
                    }
                    fontSize="26px"
                    fontColor="#FFFFFF"
                    selectionStyle="background"
                    gapBetweenColumn={15}
                    data={seasonTab}
                    RowlListcallBack={RowlListcallBack}
                    handleBackButton={handleBackButton}
                    handleRowListDownButton={handleRowListDownButton}
                    handleRowListUpButton={handleRowListUpButton}
                    isOnfocusDataLoad={true}
                    activeStyle={"underline"}
                  />
                </div>
              ) : (
                ""
              )}
              <div
                id="your-markupgrid-id"
                style={{
                  position: "absolute",
                  width: "95vw",
                  background: "transparent",
                  marginTop: episodeMarginTop,
                  marginLeft: "70px",
                }}
              >
                <MarkupGrid
                  items={TabContent}
                  forceThumbnailType={selectedItemId}
                 shouldRental={shouldRental}
                  onItemSelected={handleItemSelected}
                  rowWidth="100%"
                  rowHeight={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? 249
                      : selectedItemId === "castcrew"
                        ? (resolution === "FHD" ? 270 : 230)
                        : selectedItemId === "similaritems"
                          ? (resolution === "FHD" ? 315 : 300)
                          : 395
                  }
                  // MODIFICATION END
                  columnWidth={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? (resolution === "FHD" ? 394 : 152)
                      : selectedItemId === "similaritems"
                        ? (resolution === "FHD" ? 228 : 180)
                        : (resolution === "FHD" ? 394 : 152)
                  }
                  // MODIFICATION START: Increased columnHeight for castcrew to prevent cropping
                  columnHeight={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? (resolution === "FHD" ? 221 : 194)
                      : selectedItemId === "castcrew"
                        ? (resolution === "FHD" ? 260 : 220)
                        : selectedItemId === "similaritems"
                          ? (resolution === "FHD" ? 281 : 270)
                          : (resolution === "FHD" ? 221 : 194)
                  }
                  // MODIFICATION END
                  itemWidth={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? (resolution === "FHD" ? 404 : 152)
                      : selectedItemId === "similaritems"
                        ? (resolution === "FHD" ? 285 : 190)
                        : (resolution === "FHD" ? 404 : 152)
                  }
                  itemHeight={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? (resolution === "FHD" ? 232 : 194)
                      : selectedItemId === "castcrew"
                        ? (resolution === "FHD" ? 150 : 150)
                        : selectedItemId === "similaritems"
                          ? (resolution === "FHD" ? 422 : 280)
                          : (resolution === "FHD" ? 232 : 194)
                  }
                  numberOfDefaultRows={selectedItemId === "similaritems" ? 3 : 2}
                  selectionColor={
                    shouldFocusToEpisodeGrid ? "#fff" : "transparent"
                  }
                  numberOfColumnsEachRow={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? 4
                      : selectedItemId === "similaritems"
                        ? 8
                        : selectedItemId === "castcrew"
                          ? 9
                          : 4
                  }
                  selectionStyle="border"
                  gapBetweenColumns={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? 35
                      : selectedItemId === "similaritems"
                        ? 10
                        : selectedItemId === "castcrew"
                          ? 20
                          : 35
                  }
                  // MODIFICATION START: Reduced gapBetweenRows for castcrew
                  gapBetweenRows={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? (resolution === "FHD" ? 5 : 7)
                      : selectedItemId === "castcrew"
                        ? (resolution === "FHD" ? 15 : 5)
                        : selectedItemId === "similaritems"
                          ? (resolution === "FHD" ? 0 : 10)
                          : (resolution === "FHD" ? 10 : 7)
                  }
                  columnBgColorOrImage={ThumbnailnoImage}
                  rowBgColorOrImage="#0E1653"
                  shouldScrollHorizontally={false}
                  shouldScrollVertically={true}
                  scrollDuration={200}
                  GridXCordinate={0}
                  GridYCordinate={0}
                  shouldFocus={shouldFocusToEpisodeGrid}
                  callBack={handleMarkupGridBack}
                  itemComponentName={
                    (isLiveScreen && selectedItemId === 'similaritems')
                      ? 'EpisodesWidget'
                      : selectedItemId === "similaritems"
                        ? "SimilarToThis"
                        : itemComponentName
                  }
                  // itemComponentName={itemComponentName}
                  handleUPButton={handleMarkipGridUpButton}
                />
              </div>
            </div>
          ))}
    </div>
  );
};

HomeScreenBGItemScreen.setFocus = () => {
  addKeyListener();
};

HomeScreenBGItemScreen.ReseTfocus = (focusedIndex) => {
  ReseTfocus1(1);
};

export default HomeScreenBGItemScreen;